// This file is auto-generated by @hey-api/openapi-ts

import * as v from 'valibot';

/**
 * List of objects from the object sync
 */
export const vObjectSyncFetchObjects = v.object({
  type: v.string(),
  status: v.number(),
  range: v.optional(v.string()),
  objects: v.array(v.record(v.string(), v.unknown())),
});

export const vObjectSyncFetchObjectList = v.array(vObjectSyncFetchObjects);

/**
 * GetAvailableRegionsResponse
 */
export const vGetAvailableRegionsResponse = v.object({
  isMaster: v.boolean(),
  origin: v.string(),
  location: v.string(),
  serviceRegion: v.string(),
  awsRegion: v.string(),
  region: v.picklist(['us', 'eu', 'ap', 'ap-au']),
  'map-bbox': v.array(v.number()),
  'tc-api': v.string(),
  'objects-sync-api': v.string(),
  'org-api': v.string(),
  'pset-api': v.string(),
  'projects-api': v.string(),
  'wopi-api': v.string(),
  'batch-api': v.string(),
  'user-api': v.string(),
  'model-api': v.string(),
  'topic-api': v.string(),
});

/**
 * ModifiedBy
 *
 * User details of who modified this object recently
 */
export const vModifiedBy = v.object({
  id: v.string(),
  tiduuid: v.optional(v.string()),
  firstName: v.string(),
  lastName: v.string(),
  email: v.string(),
  status: v.picklist(['ACTIVE', 'PENDING', 'REMOVED']),
});

/**
 * UpdateCompanyRequest
 */
export const vUpdateCompanyRequest = v.object({
  name: v.optional(v.string()),
  website: v.optional(v.string()),
  domains: v.optional(v.array(v.string())),
});

/**
 * AddUserstoCompanyRequest
 */
export const vAddUserstoCompanyRequest = v.object({
  id: v.optional(v.string()),
  email: v.optional(v.string()),
  role: v.optional(v.picklist(['ADMIN', 'USER'])),
});

/**
 * UpdateUserintheCompanyRequest
 */
export const vUpdateUserintheCompanyRequest = v.object({
  role: v.picklist(['ADMIN', 'USER']),
});

/**
 * ProjectMeResponse
 */
export const vProjectMeResponse = v.array(
  v.object({
    id: v.optional(v.string()),
    role: v.optional(v.string()),
    groups: v.optional(
      v.array(
        v.object({
          id: v.string(),
        })
      )
    ),
  })
);

/**
 * usersMetrics
 */
export const vUsersMetrics = v.object({
  count: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  deleted: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
});

/**
 * fileStorageMetrics
 */
export const vFileStorageMetrics = v.object({
  activeSize: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  billedSize: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  filesCount: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  foldersCount: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  versionsCount: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
});

/**
 * ProjectMetricsResponse
 */
export const vProjectMetricsResponse = v.object({
  users: v.optional(vUsersMetrics),
  fileStorage: v.optional(vFileStorageMetrics),
});

/**
 * ViewProjectLicenseDetailsResponse
 */
export const vProjectListLicenseResponse = v.object({
  appAccess: v.boolean(),
  policyType: v.string(),
});

/**
 * ProjectMinimalDetailsResponse
 */
export const vProjectMinimalDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  location: v.string(),
  license: vProjectListLicenseResponse,
});

/**
 * ProjectCrs
 *
 * CRS information of the project contains the fields - name and csib64. All the fields in the CRS are String and optional.
 */
export const vCrs = v.object({
  name: v.optional(v.string()),
  csib64: v.optional(v.string()),
});

/**
 * ProjectAddress
 *
 * Text is the textual representation of the address. Geometry is the project boundary as an array of lat, long coordinates (either a single point or a closed polygon).
 */
export const vAddress = v.object({
  text: v.optional(v.string()),
  geometry: v.optional(v.string()),
});

/**
 * ProjectAccount
 *
 * Project Account information about account-based access policies
 */
export const vAccounts = v.object({
  accountId: v.optional(v.string()),
  accountTRN: v.optional(v.string()),
  name: v.optional(v.string()),
  type: v.optional(v.string()),
  source: v.optional(v.string()),
  adminPortalUrl: v.optional(v.string()),
  primary: v.optional(v.boolean()),
  policyType: v.optional(v.string()),
});

/**
 * UpdatedBy
 */
export const vUpdatedBy = v.object({
  id: v.string(),
  firstName: v.string(),
  lastName: v.string(),
  email: v.string(),
  status: v.string(),
});

/**
 * LicenseDetails
 *
 * Information about the license the project is associated with. An empty object for “license” property indicates that the project does not have any license mapped with it in ECom Enforcement rules
 */
export const vLicense = v.object({
  id: v.string(),
  subscriptionId: v.string(),
  orgName: v.string(),
  ownerId: v.string(),
  accounts: v.array(vAccounts),
  ecomSource: v.string(),
  type: v.string(),
  sku: v.string(),
  skuType: v.string(),
  name: v.string(),
  description: v.string(),
  maxProjects: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  maxStorage: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  maxInvites: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  maxCollaborators: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  maxUsers: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  maxForms: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  mrp: v.boolean(),
  statusShare: v.boolean(),
  usedInvites: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  usedProjects: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  usedStorage: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  upgradeLink: v.string(),
  ecomAdminPortalUrl: v.string(),
});

/**
 * UpdateProjectRequest
 */
export const vUpdateProjectRequest = v.object({
  name: v.optional(v.string()),
  address: v.optional(vAddress),
  description: v.optional(v.string()),
  startDate: v.optional(v.string()),
  endDate: v.optional(v.string()),
  lastVisitedOn: v.optional(v.string()),
  crs: v.optional(vCrs),
});

/**
 * CreateaNewProjectRequest
 */
export const vCreateaNewProjectRequest = v.object({
  name: v.string(),
  crs: v.optional(vCrs),
  description: v.string(),
  startDate: v.optional(v.string()),
  endDate: v.optional(v.string()),
  address: v.optional(vAddress),
  licenseId: v.optional(v.string()),
});

/**
 * ProjectAccessRequest
 */
export const vProjectAccessRequest = v.object({
  projectId: v.string(),
});

/**
 * AddUserstoprojectRequest
 */
export const vAddUserstoprojectRequest = v.object({
  email: v.string(),
  role: v.string(),
});

/**
 * UpdateUserroleRequest
 */
export const vUpdateUserroleRequest = v.object({
  role: v.string(),
});

/**
 * Created by user
 */
export const vProjectCloneCreatedBy = v.object({
  id: v.string(),
});

/**
 * Result with details of cloned project in case of successful clone
 */
export const vProjectCloneResult = v.object({
  projectId: v.optional(v.string()),
});

/**
 * Error details in case of failed clone
 */
export const vProjectCloneError = v.object({
  message: v.optional(v.string()),
  code: v.optional(v.string()),
});

/**
 * Project Details
 */
export const vTargetProjectDetails = v.object({
  name: v.string(),
  description: v.optional(v.string()),
  startDate: v.optional(v.string()),
  endDate: v.optional(v.string()),
  licenseId: v.optional(v.string()),
  address: v.optional(vAddress),
  crs: v.optional(vCrs),
});

/**
 * Project Clone Request
 */
export const vProjectCloneRequest = v.object({
  sourceProjectId: v.string(),
  include: v.array(
    v.picklist([
      'folders',
      'folderPermissions',
      'users',
      'groups',
      'settings',
      '*',
    ])
  ),
  targetProjectDetails: v.optional(vTargetProjectDetails),
});

/**
 * Project Clone Response
 */
export const vProjectCloneResponse = v.object({
  cloneId: v.string(),
  status: v.picklist(['QUEUED', 'PROCESSING', 'ERROR', 'DONE']),
  input: vProjectCloneRequest,
  createdBy: vProjectCloneCreatedBy,
  createdAt: v.string(),
  updatedAt: v.string(),
});

/**
 * Get Project Clone Response
 */
export const vGetProjectCloneResponse = v.object({
  cloneId: v.string(),
  status: v.picklist(['QUEUED', 'PROCESSING', 'ERROR', 'DONE']),
  input: vProjectCloneRequest,
  createdBy: vProjectCloneCreatedBy,
  createdAt: v.string(),
  updatedAt: v.string(),
  completedAt: v.optional(v.string()),
  result: v.optional(vProjectCloneResult),
  error: v.optional(vProjectCloneError),
});

/**
 * ViewerBackground
 */
export const vViewerBackground = v.object({
  r: v.number(),
  g: v.number(),
  b: v.number(),
  a: v.number(),
});

/**
 * GetUserDetailsResponse
 */
export const vGetUserDetailsResponse = v.object({
  id: v.string(),
  tiduuid: v.optional(v.string()),
  firstName: v.string(),
  lastName: v.string(),
  email: v.string(),
  status: v.picklist(['ACTIVE', 'PENDING', 'REMOVED']),
  role: v.string(),
  viewerBackground: v.optional(vViewerBackground),
  timeZone: v.optional(v.string()),
  title: v.optional(v.string()),
  phone: v.optional(v.string()),
  thumbnail: v.optional(v.string()),
  language: v.optional(v.string()),
  createdOn: v.optional(v.string()),
  modifiedOn: v.optional(v.string()),
  lastAccessed: v.optional(v.string()),
});

/**
 * SyncSettingFilter
 */
export const vSyncSettingFilter = v.object({
  id: v.string(),
  description: v.string(),
  checked: v.boolean(),
});

/**
 * SyncSettings
 */
export const vSyncSettings = v.object({
  projectId: v.string(),
  syncMode: v.string(),
  filters: v.array(vSyncSettingFilter),
});

/**
 * FileNotificationSettings
 */
export const vFileNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * FolderNotificationSettings
 */
export const vFolderNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * UserNotificationSettings
 */
export const vUserNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * ViewNotificationSettings
 */
export const vViewNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * ClashsetNotificationSettings
 */
export const vClashsetNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * ReleaseNotificationSettings
 */
export const vReleaseNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * TodoNotificationSettings
 */
export const vTodoNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * CommentNotificationSettings
 */
export const vCommentNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * OtherNotificationSettings
 */
export const vOtherNotificationSettings = v.object({
  instantNotification: v.boolean(),
  dailyDigestNotification: v.boolean(),
  activityName: v.string(),
  activityId: v.string(),
  activityNotificationSettingId: v.string(),
});

/**
 * ListOfNotificationSettings
 */
export const vListOfNotificationSettings = v.object({
  files: v.optional(v.array(vFileNotificationSettings)),
  folders: v.optional(v.array(vFolderNotificationSettings)),
  users: v.optional(v.array(vUserNotificationSettings)),
  views: v.optional(v.array(vViewNotificationSettings)),
  clashsets: v.optional(v.array(vClashsetNotificationSettings)),
  releases: v.optional(v.array(vReleaseNotificationSettings)),
  todo: v.optional(v.array(vTodoNotificationSettings)),
  comments: v.optional(v.array(vCommentNotificationSettings)),
  other: v.optional(v.array(vOtherNotificationSettings)),
});

/**
 * DailyDigestTimeZone
 */
export const vDailyDigestTimeZone = v.object({
  dailyDigestTime: v.string(),
  id: v.string(),
  label: v.string(),
});

/**
 * NotificationSettings
 */
export const vNotificationSettings = v.object({
  projectId: v.string(),
  notificationSettings: vListOfNotificationSettings,
  allowUserSettings: v.boolean(),
  dailyDigestTimeZone: vDailyDigestTimeZone,
});

/**
 * UnitSettings
 */
export const vUnitSettings = v.object({
  unitsystem: v.string(),
  lengthunit: v.string(),
  lengthunitformat: v.string(),
  lengthmeasurementunit: v.string(),
  lengthmeasurementunitformat: v.string(),
  areaunit: v.string(),
  areaunitformat: v.string(),
  volumeunit: v.string(),
  volumeunitformat: v.string(),
  weightunit: v.string(),
  weightunitformat: v.string(),
  angularunit: v.string(),
  angularunitformat: v.string(),
});

/**
 * GetProjectSettingsResponse
 */
export const vGetProjectSettingsResponse = v.object({
  syncSettings: v.optional(vSyncSettings),
  notificationSettings: v.optional(vNotificationSettings),
  unitSettings: v.optional(vUnitSettings),
  isTodosRestricted: v.optional(v.boolean()),
  isProjectInviteRestricted: v.optional(v.boolean()),
});

/**
 * UpdateProjectSettingsRequest
 */
export const vUpdateProjectSettingsRequest = v.object({
  syncSettings: v.optional(vSyncSettings),
  notificationSettings: v.optional(vNotificationSettings),
  unitSettings: v.optional(vUnitSettings),
  isTodosRestricted: v.optional(v.boolean()),
  isProjectInviteRestricted: v.optional(v.boolean()),
});

/**
 * Path
 */
export const vPath = v.object({
  id: v.string(),
  name: v.string(),
  versionId: v.string(),
});

/**
 * UpdateFolderRequest
 */
export const vUpdateFolderRequest = v.object({
  name: v.optional(v.string()),
  parentId: v.optional(v.string()),
});

/**
 * TagInFolderRequest
 */
export const vTagInFolderRequest = v.object({
  id: v.optional(v.string()),
  label: v.optional(v.string()),
  description: v.optional(v.string()),
});

/**
 * CreateaNewFolderRequest
 */
export const vCreateaNewFolderRequest = v.object({
  name: v.string(),
  parentId: v.string(),
  tags: v.optional(v.array(vTagInFolderRequest)),
});

/**
 * ListItemsErrorResponseV21
 *
 * Standard error response format for List Items API
 */
export const vListItemsErrorResponseV21 = v.object({
  error: v.picklist([
    'INVALID_ARGUMENTS',
    'UNAUTHORIZED',
    'INTERNAL_ERROR',
    'NOT_FOUND',
  ]),
  message: v.string(),
});

/**
 * PermissionResponse
 */
export const vPermissionResponse = v.object({
  id: v.string(),
  type: v.picklist(['USER', 'GROUP']),
  name: v.string(),
  permission: v.picklist(['NO_ACCESS', 'READ', 'FULL_ACCESS']),
});

/**
 * FolderPermissionsResponse
 */
export const vFolderPermissionsResponse = v.object({
  defaultPermission: v.picklist(['NO_ACCESS', 'READ', 'FULL_ACCESS']),
  permissions: v.array(vPermissionResponse),
});

/**
 * PermissionRequest
 */
export const vPermissionRequest = v.object({
  id: v.string(),
  type: v.picklist(['USER', 'GROUP']),
  permission: v.picklist(['NO_ACCESS', 'READ', 'FULL_ACCESS']),
});

/**
 * FolderPermissionRequest
 */
export const vFolderPermissionRequest = v.object({
  defaultPermission: v.optional(
    v.picklist(['NO_ACCESS', 'READ', 'FULL_ACCESS'])
  ),
  cascade: v.optional(v.string()),
  permissions: v.optional(v.array(vPermissionRequest)),
});

/**
 * FileCreationRequest
 */
export const vFileCreationRequest = v.object({
  parentId: v.string(),
  parentType: v.optional(v.string()),
  fromFileVersionId: v.string(),
  mergeExisting: v.boolean(),
  copyMetaData: v.optional(v.boolean()),
});

/**
 * Tags
 */
export const vTags = v.object({
  id: v.string(),
  projectId: v.string(),
  label: v.string(),
  description: v.string(),
});

/**
 * CheckedOutBy
 */
export const vCheckedOutBy = v.object({
  id: v.string(),
  tiduuid: v.optional(v.string()),
  firstName: v.string(),
  lastName: v.string(),
  email: v.string(),
  status: v.picklist(['ACTIVE', 'PENDING', 'REMOVED']),
});

/**
 * UpdateFileDetailsRequest
 */
export const vUpdateFileDetailsRequest = v.object({
  name: v.optional(v.string()),
  parentId: v.optional(v.string()),
});

/**
 * DownloadURLResponse
 */
export const vDownloadUrlResponse = v.object({
  id: v.string(),
  versionId: v.string(),
  url: v.string(),
});

/**
 * GetprocessingstatusofaFileResponse
 */
export const vGetprocessingstatusofaFileResponse = v.object({
  status: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

/**
 * ListSupported2D,3D&SpatialfileformatsResponse
 */
export const vListSupported2D3dSpatialFileFormatsResponse = v.object({
  extensions3D: v.array(v.string()),
  extensions2D: v.array(v.string()),
  extensionsSpatial: v.array(v.string()),
});

/**
 * FileExportDetails
 */
export const vFileExportDetails = v.object({
  id: v.string(),
  projectId: v.string(),
  status: v.string(),
  downloadUrl: v.optional(v.string()),
});

/**
 * CreateAlignmentRequest
 */
export const vCreateAlignmentRequest = v.object({
  locationX: v.number(),
  locationY: v.number(),
  locationZ: v.number(),
  axisX: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  axisY: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  axisZ: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  refDirectionX: v.number(),
  refDirectionY: v.number(),
  refDirectionZ: v.number(),
  scale: v.number(),
});

/**
 * CreateAlignmentWithMatrixRequest
 */
export const vCreateAlignmentWithMatrixRequest = v.object({
  matrix: v.array(v.number()),
});

/**
 * CreateaNewGroupRequest
 */
export const vCreateaNewGroupRequest = v.object({
  name: v.string(),
  projectId: v.string(),
});

/**
 * RenameGroupRequest
 */
export const vRenameGroupRequest = v.object({
  name: v.string(),
});

/**
 * ListUsersinaGroupResponse
 */
export const vUsersinaGroupResponse = v.object({
  id: v.string(),
  firstName: v.string(),
  lastName: v.string(),
  email: v.string(),
  status: v.string(),
  skypeId: v.optional(v.string()),
  linkedinId: v.optional(v.string()),
});

/**
 * AdduserstogroupRequest
 */
export const vAdduserstogroupRequest = v.object({
  id: v.string(),
});

/**
 * UpdateUserDetailsRequest
 */
export const vUpdateUserDetailsRequest = v.object({
  language: v.optional(v.string()),
  timeZone: v.optional(v.string()),
  phone: v.optional(v.string()),
  podLocation: v.optional(v.string()),
  viewBackground: v.optional(v.string()),
});

/**
 * Recipient
 */
export const vRecipient = v.object({
  id: v.string(),
  type: v.picklist(['USER', 'GROUP']),
  label: v.optional(v.string()),
});

/**
 * EditReleaseRequest
 */
export const vEditReleaseRequest = v.object({
  recipients: v.array(vRecipient),
});

/**
 * CreateaNewReleaseRequest
 */
export const vCreateaNewReleaseRequest = v.object({
  name: v.string(),
  dueDate: v.string(),
  projectId: v.string(),
  notes: v.optional(v.string()),
  recipients: v.optional(vRecipient),
});

/**
 * ListreleasefilesResponse
 */
export const vReleaseFileResponse = v.object({
  id: v.string(),
  name: v.string(),
  type: v.string(),
  versionId: v.string(),
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  thumbnailUrl: v.optional(v.string()),
  revision: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

/**
 * AddreleasefilesRequest
 */
export const vAddReleaseFilesRequest = v.object({
  id: v.string(),
  type: v.string(),
});

/**
 * Notify
 */
export const vNotify = v.object({
  id: v.string(),
  type: v.picklist(['USER', 'GROUP', 'EMAIL']),
});

/**
 * ShareObject
 */
export const vShareObject = v.object({
  id: v.string(),
  type: v.string(),
  url: v.string(),
  useLatestVersion: v.boolean(),
  name: v.string(),
  path: v.optional(v.string()),
  parentId: v.optional(v.string()),
});

/**
 * CreateShareObject
 */
export const vCreateShareObject = v.object({
  id: v.string(),
  type: v.string(),
  url: v.string(),
  useLatestVersion: v.boolean(),
});

/**
 * ShareObjectRequest
 */
export const vShareObjectRequest = v.object({
  id: v.string(),
  type: v.string(),
  useLatestVersion: v.optional(v.boolean()),
});

/**
 * EditShareRequest
 */
export const vEditShareRequest = v.object({
  mode: v.optional(v.picklist(['PROJECT_USERS', 'REGISTERED_USERS', 'PUBLIC'])),
  expiryDate: v.optional(v.string()),
  permission: v.optional(v.picklist(['VIEW', 'DOWNLOAD'])),
  notify: v.optional(v.array(vNotify)),
  message: v.optional(v.string()),
  objects: v.optional(v.array(vShareObjectRequest)),
});

/**
 * CreateaNewShareRequest
 */
export const vCreateaNewShareRequest = v.object({
  mode: v.picklist(['PROJECT_USERS', 'REGISTERED_USERS', 'PUBLIC']),
  projectId: v.string(),
  objects: v.array(vShareObjectRequest),
  permission: v.optional(v.picklist(['VIEW', 'DOWNLOAD'])),
  notify: v.optional(v.array(v.picklist(['USER', 'GROUP', 'EMAIL']))),
  expiryDate: v.optional(v.string()),
  message: v.optional(v.string()),
});

/**
 * AssigneesRequest
 *
 * List of users or groups assigned to ToDo.
 */
export const vAssigneesRequest = v.object({
  id: v.string(),
  type: v.picklist(['USER', 'GROUP']),
});

/**
 * UpdateToDoRequest
 */
export const vUpdateToDoRequest = v.object({
  type: v.optional(
    v.picklist([
      'Fault',
      'Clash',
      'Request',
      'Inquiry',
      'Remark',
      'Comment',
      'Issue',
      'Request',
      'Solution',
    ])
  ),
  title: v.optional(v.string()),
  label: v.optional(v.string()),
  description: v.optional(v.string()),
  dueDate: v.optional(v.string()),
  percentComplete: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1'),
      v.minValue(0),
      v.maxValue(100)
    )
  ),
  status: v.optional(
    v.picklist(['NEW', 'IN_PROGRESS', 'RESOLVED', 'BLOCKED', 'CLOSED'])
  ),
  priority: v.optional(v.picklist(['LOW', 'NORMAL', 'HIGH', 'CRITICAL'])),
  assignees: v.optional(vAssigneesRequest),
});

/**
 * CreateaNewToDoRequest
 */
export const vCreateaNewToDoRequest = v.object({
  description: v.string(),
  projectId: v.string(),
  type: v.optional(
    v.picklist([
      'Fault',
      'Clash',
      'Request',
      'Inquiry',
      'Remark',
      'Comment',
      'Issue',
      'Request',
      'Solution',
    ])
  ),
  title: v.optional(v.string()),
  label: v.optional(v.string()),
  dueDate: v.optional(v.string()),
  percentComplete: v.optional(
    v.pipe(
      v.number(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1'),
      v.minValue(0),
      v.maxValue(100)
    )
  ),
  status: v.optional(
    v.picklist(['NEW', 'IN_PROGRESS', 'RESOLVED', 'BLOCKED', 'CLOSED'])
  ),
  priority: v.optional(v.picklist(['LOW', 'NORMAL', 'HIGH', 'CRITICAL'])),
  assignees: v.optional(vAssigneesRequest),
});

/**
 * AttachmentDetailsResponse
 */
export const vTodoAttachmentDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  type: v.string(),
  versionId: v.string(),
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  revision: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

/**
 * AddattachmentsRequest
 */
export const vAddTodoattachmentsRequest = v.object({
  id: v.string(),
  type: v.picklist(['FILE', 'VIEW', 'CLASHSET', 'CLASHITEM', 'VIEW2D']),
  embedded: v.optional(v.string()),
});

/**
 * UpdateViewGroupDetailsRequest
 */
export const vUpdateViewGroupDetailsRequest = v.object({
  name: v.optional(v.string()),
  views: v.optional(v.array(v.string())),
});

/**
 * CreateaViewGroupRequest
 */
export const vCreateaViewGroupRequest = v.object({
  projectId: v.string(),
  name: v.string(),
  views: v.optional(v.array(v.string())),
});

/**
 * AssigneeResponse
 *
 * Assignee are the users who got assigned with some task
 */
export const vAssigneeResponse = v.object({
  id: v.string(),
  tiduuid: v.optional(v.string()),
  type: v.picklist(['USER', 'GROUP']),
  firstName: v.string(),
  lastName: v.string(),
  name: v.string(),
  email: v.string(),
});

/**
 * BackgroundColor
 *
 * Background colour details
 */
export const vBackgroundColor = v.object({
  r: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  g: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  b: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  a: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

/**
 * Camera
 */
export const vCamera = v.object({
  cameraId: v.string(),
  targetX: v.number(),
  targetY: v.number(),
  targetZ: v.number(),
  upX: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  upY: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  upZ: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  distance: v.number(),
  pitch: v.number(),
  yaw: v.number(),
  projectionType: v.picklist(['ortho', 'perspective']),
  viewId: v.optional(v.string()),
  viewAngle: v.optional(v.number()),
  viewScale: v.optional(v.number()),
});

/**
 * SectionPlane
 */
export const vSectionPlane = v.object({
  sectionPlaneId: v.optional(v.string()),
  directionX: v.number(),
  directionY: v.number(),
  directionZ: v.number(),
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  referenceObject: v.optional(v.string()),
});

/**
 * SectionBox
 */
export const vSectionBox = v.object({
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  sizeX: v.number(),
  sizeY: v.number(),
  sizeZ: v.number(),
  rotationX: v.number(),
  rotationY: v.number(),
  rotationZ: v.number(),
  rotationW: v.number(),
  excludedVersionIds: v.optional(v.array(v.string())),
});

/**
 * MarkUpCloudType
 */
export const vMarkUpCloudType = v.object({
  planeA: v.number(),
  planeB: v.number(),
  planeC: v.number(),
  planeD: v.number(),
  width: v.number(),
  height: v.number(),
});

/**
 * MarkUpTextType
 */
export const vMarkUpTextType = v.object({
  position2X: v.number(),
  position2Y: v.number(),
  position2Z: v.number(),
  screenSpaceDistance: v.optional(v.number()),
  text: v.string(),
  width: v.optional(v.number()),
});

/**
 * MarkUpLineType
 */
export const vMarkUpLineType = v.object({
  position2X: v.number(),
  position2Y: v.number(),
  position2Z: v.number(),
});

/**
 * MarkUpArrowType
 */
export const vMarkUpArrowType = v.object({
  position2X: v.number(),
  position2Y: v.number(),
  position2Z: v.number(),
});

/**
 * MarkUpMeasureType
 */
export const vMarkUpMeasureType = v.object({
  position2X: v.number(),
  position2Y: v.number(),
  position2Z: v.number(),
  referenceObject2: v.optional(v.string()),
});

/**
 * Line
 */
export const vLine = v.object({
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  position2X: v.number(),
  position2Y: v.number(),
  position2Z: v.number(),
});

/**
 * MarkUpRedLineType
 */
export const vMarkUpRedLineType = v.object({
  camera: v.optional(vCamera),
  lines: v.optional(v.array(vLine)),
});

/**
 * Color
 */
export const vColor = v.object({
  r: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  g: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  b: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  a: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

/**
 * ElementType
 */
export const vElementType = v.object({
  type: v.string(),
  visibility: v.boolean(),
  priority: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  state: v.optional(v.number()),
  color: v.optional(vColor),
});

/**
 * Element
 */
export const vElement = v.object({
  sourceId: v.string(),
  storageObjectId: v.string(),
  state: v.number(),
  isRecursive: v.boolean(),
  xrefId: v.optional(v.string()),
  versionId: v.optional(v.string()),
  priority: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  color: vColor,
});

/**
 * Presentation
 */
export const vPresentation = v.object({
  ghost: v.optional(v.boolean()),
  transparent: v.optional(v.boolean()),
  wireframe: v.optional(v.boolean()),
  isNewEnabled: v.optional(v.boolean()),
  isPendingEnabled: v.optional(v.boolean()),
  isCriticalEnabled: v.optional(v.boolean()),
  isResolvedEnabled: v.optional(v.boolean()),
  isIgnoredEnabled: v.optional(v.boolean()),
  isNotesEnabled: v.optional(v.boolean()),
  isDocumentsEnabled: v.optional(v.boolean()),
  transparencyLevel: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  elementTypes: v.optional(v.array(vElementType)),
  elements: v.optional(v.array(vElement)),
});

/**
 * Point
 */
export const vMarkupPickPointType = v.object({
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  referenceObject: v.optional(v.string()),
});

/**
 * MeasurePickLineType
 *
 * This schema applies for the _line and lineSegment_ type
 */
export const vMeasurePickLineType = v.object({
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  position2X: v.number(),
  position2Y: v.number(),
  position2Z: v.number(),
  referenceObject: v.optional(v.string()),
});

/**
 * Plane
 */
export const vMarkupPickPlaneType = v.object({
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  directionX: v.number(),
  directionY: v.number(),
  directionZ: v.number(),
  referenceObject: v.optional(v.string()),
});

/**
 * Start
 *
 * Measure with pick posses the following types for a start object, _point, line, lineSegment, plane_
 */
export const vMeasureWithPickStart = v.object({
  type: v.string(),
  'type(if type=point)': v.optional(vMarkupPickPointType),
  'type(if type=line)': v.optional(vMeasurePickLineType),
  'type(if type=lineSegment)': v.optional(vMeasurePickLineType),
  'type(if type=plane)': v.optional(vMarkupPickPlaneType),
});

/**
 * End
 *
 * Measure with pick posses the following types for a end object, _point, line, lineSegment, plane_
 */
export const vMeasureWithPickEnd = v.object({
  type: v.string(),
  'type(if type=point)': v.optional(vMarkupPickPointType),
  'type(if type=line)': v.optional(vMeasurePickLineType),
  'type(if type=lineSegment)': v.optional(vMeasurePickLineType),
  'type(if type=plane)': v.optional(vMarkupPickPlaneType),
});

/**
 * MarkUpMeasureWithPickType
 */
export const vMarkUpMeasureWithPickType = v.object({
  start: vMeasureWithPickStart,
  end: vMeasureWithPickEnd,
  unitType: v.optional(v.string()),
  quantityUnit: v.optional(v.string()),
  quantityUnitFormat: v.optional(v.string()),
  referenceObject2: v.optional(v.string()),
});

/**
 * MarkUpMeasureSlopeType
 */
export const vMarkUpMeasureSlopeType = v.object({
  start: vMeasureWithPickStart,
  end: vMeasureWithPickEnd,
  unitType: v.optional(v.string()),
  quantityUnit: v.optional(v.string()),
  quantityUnitFormat: v.optional(v.string()),
  referenceObject2: v.optional(v.string()),
  slopeDisplayType: v.optional(v.string()),
  slopeDisplayMode: v.optional(v.string()),
  lineOrthoMode: v.optional(v.string()),
  slopePrecision: v.optional(v.pipe(v.number(), v.integer())),
});

/**
 * AnglePickLineType
 *
 * This schema applies for the _line and lineSegment_ type
 */
export const vAnglePickLineType = v.object({
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  position2X: v.number(),
  position2Y: v.number(),
  position2Z: v.number(),
  directionX: v.optional(v.number()),
  directionY: v.optional(v.number()),
  directionZ: v.optional(v.number()),
  referenceObject: v.optional(v.string()),
});

/**
 * Start
 *
 * Angle pick posses the following types for a start object, _point, line, lineSegment, plane_
 */
export const vAnglePickStart = v.object({
  type: v.string(),
  'type(if type=point)': v.optional(vMarkupPickPointType),
  'type(if type=line)': v.optional(vAnglePickLineType),
  'type(if type=lineSegment)': v.optional(vAnglePickLineType),
  'type(if type=plane)': v.optional(vMarkupPickPlaneType),
});

/**
 * End
 *
 * Angle pick posses the following types for a end object, _point, line, lineSegment, plane_
 */
export const vAnglePickEnd = v.object({
  type: v.string(),
  'type(if type=point)': v.optional(vMarkupPickPointType),
  'type(if type=line)': v.optional(vAnglePickLineType),
  'type(if type=lineSegment)': v.optional(vAnglePickLineType),
  'type(if type=plane)': v.optional(vMarkupPickPlaneType),
});

/**
 * MarkUpAngleType
 *
 * Angle markup type would cover the following two cases _two pick_ and _three pick_. On _two pick_ case start and end fields can be considered as first pick and second pick respectively with its schema type followed, and fields like positionX, positionY, positionZ of the markup can be omitted. On _three pick_ case in addition to start and end field, fields like positionX, positionY, positionZ of the markup can be considered as an additional pick of type point.
 */
export const vMarkUpAngleType = v.object({
  start: vAnglePickStart,
  end: vAnglePickEnd,
});

/**
 * Markup
 */
export const vMarkup = v.object({
  type: v.picklist([
    'cloud',
    'text',
    'line',
    'arrow',
    'redlines',
    'measure',
    'measure_with_pick',
    'angle',
    'measure_slope',
  ]),
  markupId: v.optional(v.string()),
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  projectId: v.optional(v.string()),
  mashupId: v.optional(v.string()),
  referenceObject: v.optional(v.string()),
  color: v.optional(vColor),
  'type(if type=cloud)': v.optional(vMarkUpCloudType),
  'type(if type=text)': v.optional(vMarkUpTextType),
  'type(if type=line)': v.optional(vMarkUpLineType),
  'type(if type=arrow)': v.optional(vMarkUpArrowType),
  'type(if type=redlines)': v.optional(vMarkUpRedLineType),
  'type(if type=measure)': v.optional(vMarkUpMeasureType),
  'type(if type=measure_with_pick)': v.optional(vMarkUpMeasureWithPickType),
  'type(if type=angle)': v.optional(vMarkUpAngleType),
  'type(if type=measure_slope)': v.optional(vMarkUpMeasureSlopeType),
});

/**
 * UpdateViewRequest
 */
export const vUpdateViewRequest = v.object({
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  backgroundColor: v.optional(vBackgroundColor),
  camera: v.optional(vCamera),
  sectionplanes: v.optional(v.array(vSectionPlane)),
  sectionBox: v.optional(vSectionBox),
  markups: v.optional(v.array(vMarkup)),
  assignees: v.optional(v.array(vAssigneesRequest)),
  models: v.optional(v.array(v.string())),
  presentation: v.optional(vPresentation),
});

/**
 * CreateViewRequest
 */
export const vCreateViewRequest = v.object({
  name: v.string(),
  description: v.optional(v.string()),
  projectId: v.string(),
  topicId: v.optional(v.string()),
  issueId: v.optional(v.string()),
  contextId: v.optional(v.string()),
  backgroundColor: v.optional(vBackgroundColor),
  models: v.array(v.string()),
  files: v.optional(v.array(v.string())),
  assignees: v.optional(v.array(vAssigneesRequest)),
  camera: vCamera,
  sectionPlanes: v.optional(v.array(vSectionPlane)),
  sectionBox: v.optional(vSectionBox),
  markups: v.optional(v.array(vMarkup)),
  presentation: v.optional(vPresentation),
  imageData: v.optional(v.string()),
});

/**
 * UpdateCameraRequest
 */
export const vUpdateCameraRequest = v.object({
  targetX: v.optional(v.number()),
  targetY: v.optional(v.number()),
  targetZ: v.optional(v.number()),
  upX: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  upY: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  upZ: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  distance: v.optional(v.number()),
  pitch: v.optional(v.number()),
  yaw: v.optional(v.number()),
  projectionType: v.optional(v.picklist(['ortho', 'perspective'])),
  viewAngle: v.optional(v.number()),
  viewScale: v.optional(v.number()),
});

/**
 * CreateSectionPlaneRequest
 */
export const vCreateSectionPlaneRequest = v.object({
  directionX: v.number(),
  directionY: v.number(),
  directionZ: v.number(),
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  referenceObject: v.optional(v.string()),
});

/**
 * UpdateSectionPlaneRequest
 */
export const vUpdateSectionPlaneRequest = v.object({
  sectionPlaneId: v.string(),
  directionX: v.number(),
  directionY: v.number(),
  directionZ: v.number(),
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  referenceObject: v.optional(v.string()),
});

/**
 * UpdateSectionBoxRequest
 */
export const vUpdateSectionBoxRequest = v.object({
  positionX: v.number(),
  positionY: v.number(),
  positionZ: v.number(),
  sizeX: v.number(),
  sizeY: v.number(),
  sizeZ: v.number(),
  rotationX: v.number(),
  rotationY: v.number(),
  rotationZ: v.number(),
  rotationW: v.number(),
  excludedVersionIds: v.optional(v.array(v.string())),
});

/**
 * CreateMarkupsRequest
 */
export const vCreateMarkupsRequest = v.object({
  type: v.string(),
  color: v.optional(vColor),
  start: v.optional(vMeasureWithPickStart),
  end: v.optional(vMeasureWithPickEnd),
  unitType: v.optional(v.string()),
  quantityUnit: v.optional(v.string()),
  quantityUnitFormat: v.optional(v.string()),
});

/**
 * UpdateMarkupRequest
 */
export const vUpdateMarkupRequest = v.object({
  markupId: v.string(),
  positionX: v.optional(v.number()),
  positionY: v.optional(v.number()),
  positionZ: v.optional(v.number()),
  color: v.optional(vColor),
  type: v.picklist([
    'cloud',
    'text',
    'line',
    'arrow',
    'redlines',
    'measure',
    'measure_with_pick',
    'angle',
    'measure_slope',
  ]),
  position2X: v.optional(v.number()),
  position2Y: v.optional(v.number()),
  position2Z: v.optional(v.number()),
  text: v.optional(v.string()),
});

/**
 * UpdatePresentationRequest
 */
export const vUpdatePresentationRequest = v.object({
  isPendingEnabled: v.optional(v.boolean()),
  isDocumentsEnabled: v.optional(v.boolean()),
  isNewEnabled: v.optional(v.boolean()),
  ghost: v.optional(v.boolean()),
  transparent: v.optional(v.boolean()),
  wireframe: v.optional(v.boolean()),
  isCriticalEnabled: v.optional(v.boolean()),
  isResolvedEnabled: v.optional(v.boolean()),
  transparencyLevel: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  elementTypes: v.optional(v.array(vElementType)),
  elements: v.optional(v.array(vElement)),
});

/**
 * UploadViewThumbnailImageResponse
 */
export const vUploadViewThumbnailImageResponse = v.object({
  id: v.string(),
  name: v.string(),
  description: v.string(),
  projectId: v.string(),
  models: v.optional(v.array(v.string())),
  thumbnail: v.string(),
});

/**
 * 2DViewMarkup
 *
 * The markup property contains the markup data properties.
 */
export const v2dViewMarkup = v.object({
  xfdfData: v.string(),
});

/**
 * Createa2DViewRequest
 */
export const vCreatea2dViewRequest = v.object({
  name: v.string(),
  description: v.string(),
  projectId: v.string(),
  versionId: v.string(),
  rotation: v.optional(v.string()),
  zoomLevel: v.optional(v.string()),
  pageNumber: v.optional(v.string()),
  assignees: v.optional(v.array(vAssigneesRequest)),
  markup: v.optional(v2dViewMarkup),
  imageData: v.optional(v.string()),
});

/**
 * Update2DViewRequest
 */
export const vUpdate2dViewRequest = v.object({
  name: v.optional(v.string()),
  description: v.optional(v.string()),
  projectId: v.optional(v.string()),
  versionId: v.optional(v.string()),
  rotation: v.optional(v.string()),
  zoomLevel: v.optional(v.string()),
  pageNumber: v.optional(v.string()),
  assignees: v.optional(v.array(vAssigneesRequest)),
  markup: v.optional(v2dViewMarkup),
  imageData: v.optional(v.string()),
});

/**
 * object associated to source.
 */
export const vTarget = v.object({
  type: v.string(),
  name: v.optional(v.string()),
  id: v.string(),
  versionId: v.optional(v.string()),
  embedded: v.optional(v.boolean()),
  contextId: v.optional(v.string()),
});

/**
 * Source object information
 */
export const vSourceDataResponse = v.object({
  type: v.string(),
  sourceId: v.string(),
  objectId: v.string(),
  xrefId: v.optional(v.string()),
});

/**
 * Source model information
 *
 * the source object. Source is mandatory in a Request but would be omitted in Response if detail parameter (default = false) is set to false.
 */
export const vSourceResponse = v.object({
  id: v.string(),
  versionId: v.string(),
  type: v.optional(v.string()),
  data: v.array(vSourceDataResponse),
});

/**
 * Source object information
 */
export const vSourceDataRequest = v.object({
  type: v.string(),
  sourceId: v.string(),
});

/**
 * Source model information
 *
 * the source object. Source is mandatory in a Request but would be omitted in Response if detail parameter (default = false) is set to false.
 */
export const vSourceRequest = v.object({
  versionId: v.string(),
  data: v.array(vSourceDataRequest),
});

/**
 * CreateObjectLinkRequest
 */
export const vCreateObjectLinkRequest = v.object({
  source: vSourceRequest,
  target: vTarget,
});

/**
 * UpdateObjectLinksRequest
 */
export const vUpdateObjectLinksRequest = v.object({
  target: vTarget,
});

/**
 * BulkCreateObjectLinksRequest
 */
export const vBulkCreateObjectLinksRequest = v.object({
  source: vSourceRequest,
  target: vTarget,
});

/**
 * CreateClashRequest
 */
export const vCreateClashRequest = v.object({
  name: v.string(),
  tolerance: v.number(),
  type: v.picklist(['CLASH', 'CLEARANCE']),
  ignoreSameDiscipline: v.boolean(),
  models: v.array(v.string()),
});

/**
 * UpdateClashRequest
 */
export const vUpdateClashRequest = v.object({
  assignees: v.optional(v.array(vAssigneesRequest)),
  name: v.optional(v.string()),
});

/**
 * ClashItemSourceId
 *
 * source id of first element
 */
export const vClashItemSourceId = v.object({
  sourceId: v.string(),
  versionId: v.string(),
});

/**
 * ClashItemCenter
 *
 * center point to represent the clash-item
 */
export const vClashItemCenter = v.object({
  x: v.number(),
  y: v.number(),
  z: v.number(),
});

/**
 * ListAllClashItemsResponse
 */
export const vListAllClashItemsResponse = v.object({
  id: v.string(),
  label: v.string(),
  distance: v.number(),
  sourceId1: vClashItemSourceId,
  sourceId2: vClashItemSourceId,
  elementName1: v.string(),
  elementName2: v.string(),
  elementType1: v.string(),
  elementType2: v.string(),
  center: vClashItemCenter,
});

/**
 * UpdateCommentRequest
 */
export const vUpdateCommentRequest = v.object({
  description: v.string(),
});

/**
 * CreateaNewCommentRequest
 */
export const vCreateaNewCommentRequest = v.object({
  objectId: v.string(),
  objectType: v.picklist([
    'FILE',
    'FOLDER',
    'VIEW',
    'CLASH',
    'RELEASE',
    'TODO',
    'ISSUE',
  ]),
  description: v.string(),
  contextId: v.optional(v.string()),
});

/**
 * AddCommentAttachmentsRequest
 */
export const vAddCommentAttachmentsRequest = v.object({
  id: v.string(),
  type: v.picklist(['FILE', 'VIEW', 'URL', 'VIEW2D', 'CLASHITEM']),
  url: v.optional(v.string()),
  urlName: v.optional(v.string()),
});

/**
 * CommentAttachmentDetailsResponse
 */
export const vCommentAttachmentDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  type: v.string(),
  versionId: v.string(),
  url: v.optional(v.string()),
  urlName: v.optional(v.string()),
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  revision: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

/**
 * AddReactionToCommentRequest
 */
export const vAddReactionToCommentRequest = v.object({
  emoji: v.string(),
});

/**
 * AddReactionToCommentResponse
 */
export const vAddReactionToCommentResponse = v.object({
  id: v.string(),
  commentId: v.string(),
  emoji: v.string(),
  createdBy: v.string(),
  createdAt: v.string(),
});

/**
 * Schema for pagination links.
 */
export const vPaginationLinks = v.object({
  first: v.optional(
    v.object({
      href: v.optional(v.pipe(v.string(), v.url())),
    })
  ),
  self: v.optional(
    v.object({
      href: v.optional(v.pipe(v.string(), v.url())),
    })
  ),
  next: v.optional(
    v.object({
      href: v.optional(v.pipe(v.string(), v.url())),
    })
  ),
});

/**
 * TagDetailsMiniRepResponse
 */
export const vTagDetailsMiniRepResponse = v.object({
  id: v.string(),
  projectId: v.string(),
  label: v.string(),
  description: v.string(),
  color: v.optional(v.string()),
});

/**
 * EditTagRequest
 */
export const vEditTagRequest = v.object({
  label: v.optional(v.string()),
  description: v.optional(v.string()),
  color: v.optional(v.string()),
});

/**
 * CreateTagRequest
 */
export const vCreateTagRequest = v.object({
  label: v.string(),
  description: v.optional(v.string()),
  projectId: v.string(),
  color: v.optional(v.string()),
});

/**
 * ObjectsinaTagResponse
 */
export const vObjectsinaTagResponse = v.object({
  id: v.string(),
  objectType: v.picklist(['FILE', 'FOLDER', 'TODO', 'TOPIC', 'ISSUE']),
  contextId: v.optional(v.string()),
  type: v.string(),
  title: v.optional(v.string()),
  label: v.optional(v.string()),
  description: v.optional(v.string()),
  dueDate: v.optional(v.string()),
  status: v.optional(
    v.picklist([
      'PENDING',
      'ON HOLD',
      'DONE',
      'CANCELLED',
      'ERROR',
      'PROCESSING',
    ])
  ),
  priority: v.optional(v.string()),
  projectId: v.string(),
  name: v.optional(v.string()),
  versionId: v.optional(v.string()),
  parentId: v.optional(v.string()),
  permission: v.optional(v.picklist(['READ', 'FULL_ACCESS'])),
  size: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  hasChildren: v.optional(v.boolean()),
  hidden: v.optional(v.boolean()),
  revision: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  thumbnailUrl: v.optional(v.array(v.string())),
  hash: v.optional(v.string()),
});

/**
 * ObjectsToTagRequest
 */
export const vObjectsToTagRequest = v.object({
  id: v.string(),
  objectType: v.picklist(['FILE', 'FOLDER', 'TODO', 'TOPIC', 'ISSUE']),
  contextId: v.optional(v.string()),
});

/**
 * ActivityMessage
 *
 * Valid only for several types of activities
 */
export const vActivityMessage = v.object({
  id: v.string(),
  displayName: v.string(),
  type: v.string(),
});

/**
 * ActivityObject
 *
 * In case of multiple activities on a group of objects that don't have a common object acted upon, the object will be null. Eg. FILE_DOWNLOAD of different files from different folders performed together as one activity.
 */
export const vActivityObject = v.object({
  id: v.string(),
  displayName: v.string(),
  type: v.string(),
});

/**
 * ActivityStatistic
 *
 * If the count > 1 and if deeper information is needed, use the /logs endpoint for fetching changed entities or fields. For latest information about the resource, use the corresponding resource endpoint.
 */
export const vActivityStatistic = v.object({
  activityType: v.string(),
  count: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

/**
 * ActivityDetailsResponse
 */
export const vActivityDetailsResponse = v.object({
  object: vActivityObject,
  statistics: v.array(vActivityStatistic),
  message: v.optional(vActivityMessage),
});

/**
 * ActivityLogsByActivityIdResponse
 */
export const vActivityLogsByActivityIdResponse = v.object({
  id: v.string(),
  displayName: v.string(),
  type: v.string(),
  activityType: v.string(),
  oldValue: v.string(),
  newValue: v.string(),
});

/**
 * CreateNewExportRequest
 */
export const vCreateNewExportRequest = v.object({
  filters: v.optional(v.array(v.string())),
  users: v.optional(v.array(v.string())),
  groups: v.optional(v.array(v.string())),
  fromDate: v.optional(v.string()),
  toDate: v.optional(v.string()),
});

/**
 * ActivityExportDetails
 */
export const vActivityExportDetails = v.object({
  id: v.string(),
  projectId: v.string(),
  status: v.string(),
  downloadUrl: v.optional(v.string()),
  filters: v.array(v.string()),
  users: v.optional(v.array(v.string())),
  groups: v.optional(v.array(v.string())),
  fromDate: v.optional(v.string()),
  toDate: v.optional(v.string()),
});

/**
 * ActivityListRequest
 */
export const vActivityListRequest = v.object({
  projectId: v.string(),
  filters: v.optional(
    v.object({
      fromDate: v.optional(v.pipe(v.string(), v.isoDate())),
      toDate: v.optional(v.pipe(v.string(), v.isoDate())),
      types: v.optional(
        v.picklist([
          'FILE_ADD',
          'FILE_DELETE',
          'FILE_MOVE',
          'FILE_RENAME',
          'FILE_DOWNLOAD',
          'FILE_CHECKOUT',
          'FILE_CHECKIN',
          'FILE_RESTORE',
          'SYNC',
          'FOLDER_ADD',
          'FOLDER_DELETE',
          'FOLDER_MOVE',
          'FOLDER_RENAME',
          'FOLDER_RESTORE',
          'FOLDER_DOWNLOAD',
          'PROJECT_JOIN',
          'USER_IN_PROJECT_ADD',
          'USER_IN_PROJECT_REMOVE',
          'USER_IN_PROJECT_LEAVE',
          'EXCEL_IMPORT_TEAM',
          'SNAPSHOT_ADD',
          'SNAPSHOT_DELETE',
          'SNAPSHOT_UPDATE',
          'SNAPSHOT_RENAME',
          'SNAPSHOT_UPDATE_DESCRIPTION',
          'VIEW2D_ADD',
          'VIEW2D_ADD_IMPLICIT',
          'VIEW2D_DELETE',
          'VIEW2D_UPDATE',
          'VIEW2D_ADD_ASSIGNEES',
          'VIEW2D_REMOVE_ASSIGNEES',
          'VIEW2D_RENAME',
          'VIEW2D_UPDATE_DESCRIPTION',
          'CLASH_ADD',
          'CLASH_DELETE',
          'RELEASE_CREATE',
          'RELEASE_ADD_FILES',
          'RELEASE_REMOVE_FILES',
          'RELEASE_FILE_DOWNLOAD',
          'RELEASE_SENT',
          'RELEASE_DELETE',
          'RELEASE_RENAME',
          'RELEASE_EDIT_DUE_DATE',
          'RELEASE_EDIT_NOTES',
          'TODO_ADD',
          'TODO_EDIT_DESCRIPTION',
          'TODO_EDIT_DUE_DATE',
          'TODO_EDIT_PERCENT_COMPLETE',
          'TODO_EDIT_PRIORITY',
          'TODO_EDIT_STATUS',
          'TODO_EDIT_TITLE',
          'TODO_EDIT_TYPE',
          'TODO_EDIT',
          'TODO_DELETE',
          'TODO_ADD_FILES',
          'TODO_REMOVE_FILES',
          'TODO_ADD_SNAPSHOTS',
          'TODO_REMOVE_SNAPSHOT',
          'TODO_SNAPSHOT_UPDATE',
          'TODO_ADD_VIEW2D',
          'TODO_REMOVE_VIEW2D',
          'TODO_VIEW2D_UPDATE',
          'TODO_ADD_CLASH_ITEM',
          'TODO_ADD_ASSIGNEES',
          'TODO_REMOVE_ASSIGNEES',
          'EXCEL_IMPORT_TODO',
          'COMMENT_ADD',
          'COMMENT_EDIT',
          'COMMENT_DELETE',
          'SHARE_ADD',
          'SHARE_DELETE',
          'SHARE_UPDATE_MODE',
          'SHARE_UPDATE_MESSAGE',
          'SHARE_UPDATE_NOTIFY',
          'SHARE_UPDATE_EXPIRY_DATE',
          'SHARE_UPDATE_PERMISSION',
          'SHARE_UPDATE_LATEST_VERSION',
          'PROJECT_RENAME',
          'PROJECT_EDIT_DESCRIPTION',
          'PROJECT_EDIT_END_DATE',
          'PROJECT_EDIT_START_DATE',
          'PROJECT_EDIT_ADDRESS',
          'PROJECT_EDIT_CRS',
          'TOPIC_CREATED',
          'TOPIC_EDITED',
          'TOPIC_DELETED',
          'TOPIC_DOCREFS_ADDED',
          'TOPIC_DOCREFS_REMOVED',
          'TOPIC_VIEW_ADDED',
          'TOPIC_VIEW_DELETED',
          'TOPIC_COMMENT_ADDED',
          'TOPIC_COMMENT_EDITED',
          'TOPIC_COMMENT_DELETED',
        ])
      ),
      users: v.optional(v.array(v.pipe(v.string(), v.uuid()))),
      groups: v.optional(v.array(v.string())),
    })
  ),
});

/**
 * ActivityResponseObject
 */
export const vActivityResponseObject = v.object({
  id: v.optional(v.string()),
  type: v.optional(v.string()),
  createdOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  createdBy: v.optional(v.pipe(v.string(), v.uuid())),
  details: v.optional(
    v.object({
      object: v.optional(vActivityObject),
      statistics: v.optional(vActivityStatistic),
    })
  ),
  status: v.optional(v.string()),
});

export const vActivityListResponse = v.array(vActivityResponseObject);

/**
 * ProjectLicenseV21
 *
 * License information for the project.
 *
 * **Note:** This object is only included in the response if:
 * 1. The `fields` parameter includes license-related fields (`license.appAccess` or `license.policyType`)
 * 2. The project has valid license information
 *
 * If not requested or if license information is unavailable, this field is omitted from the JSON response.
 *
 */
export const vProjectLicenseV21 = v.object({
  policyType: v.optional(
    v.picklist([
      'ENTERPRISE_PROJECT',
      'UNLICENSED_PROJECT',
      'LICENSED_PROJECT',
      'DERIVED',
    ])
  ),
  appAccess: v.optional(v.boolean()),
});

/**
 * ProjectItemDtoV21
 *
 * Project item representation in the v2.1 API response
 */
export const vProjectItemDtoV21 = v.object({
  id: v.string(),
  name: v.string(),
  rootId: v.string(),
  thumbnail: v.string(),
  lastVisitedOn: v.pipe(v.string(), v.isoTimestamp()),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  createdBy: v.string(),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedBy: v.string(),
  size: v.pipe(
    v.union([v.number(), v.string(), v.bigint()]),
    v.transform((x) => BigInt(x)),
    v.minValue(
      BigInt('-9223372036854775808'),
      'Invalid value: Expected int64 to be >= -2^63'
    ),
    v.maxValue(
      BigInt('9223372036854775807'),
      'Invalid value: Expected int64 to be <= 2^63-1'
    )
  ),
  description: v.optional(v.string()),
  license: v.optional(vProjectLicenseV21),
});

/**
 * ProjectsPagedResponseV21
 *
 * Paginated response containing a list of projects with navigation links
 */
export const vProjectsPagedResponseV21 = v.object({
  items: v.array(vProjectItemDtoV21),
  links: vPaginationLinks,
});

/**
 * ErrorResponseV21
 *
 * Standard error response format
 */
export const vErrorResponseV21 = v.object({
  error: v.picklist([
    'INVALID_ARGUMENTS',
    'UNAUTHORIZED',
    'INTERNAL_ERROR',
    'NOT_FOUND',
  ]),
  message: v.string(),
});

export const vApiError = v.object({
  message: v.optional(v.string()),
  details: v.optional(v.string()),
  errorcode: v.optional(v.string()),
});

/**
 * Contents can be skipped for single part source file only uploads.
 */
export const vFileUploadContentDto = v.object({
  format: v.optional(v.string()),
  fileset: v.optional(v.boolean(), false),
  multipart: v.optional(v.boolean(), false),
  size: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  path_template: v.optional(v.string()),
});

export const vFileUploadDto = v.object({
  name: v.optional(v.string()),
  contents: v.optional(v.array(vFileUploadContentDto)),
});

/**
 * content that has format not specified refers to source file
 */
export const vUploadDetailsContent = v.object({
  format: v.optional(v.string()),
  fileset: v.optional(v.boolean(), false),
  multipart: v.optional(v.boolean(), false),
  size: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  type: v.optional(v.string()),
  url: v.optional(v.string()),
  status: v.optional(v.string()),
  path_template: v.optional(v.string()),
});

export const vUserDto = v.object({
  id: v.optional(v.string()),
  tiduuid: v.optional(v.string()),
});

export const vFileUploadDetailsResponse = v.object({
  name: v.optional(v.string()),
  uploadId: v.optional(v.string()),
  parentId: v.optional(v.string()),
  parentType: v.optional(v.string()),
  projectId: v.optional(v.string()),
  status: v.optional(v.picklist(['UPLOADABLE', 'DONE', 'ERROR', 'EXPIRED'])),
  fileId: v.optional(v.string()),
  versionId: v.optional(v.string()),
  revision: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  contents: v.optional(v.array(vUploadDetailsContent)),
  created: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  modified: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  completed: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  createdBy: v.optional(vUserDto),
  errorReason: v.optional(v.string()),
});

/**
 * Parts of the file to be completed
 */
export const vPartDto = v.object({
  etag: v.string(),
  part_number: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

export const vCompleteUploadRequestDto = v.object({
  format: v.optional(v.string()),
  parts: v.array(vPartDto),
});

export const vInitiateFileUploadRequest = v.object({
  parentId: v.string(),
  name: v.string(),
  parentType: v.string(),
  numberOfParts: v.optional(v.string()),
  size: v.optional(v.string()),
  pathTemplate: v.optional(v.string()),
  fileset: v.optional(v.boolean()),
});

export const vPart = v.object({
  etag: v.optional(v.string()),
  part_number: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
});

export const vUploadParts = v.object({
  parts: v.array(vPart),
});

/**
 * This is required only for Multipart upload
 */
export const vCommitUploadDto = v.object({
  upload: vUploadParts,
});

/**
 * Commit and finalize the file upload. For multipart uploads the multipart property with list of uploaded parts is required.
 */
export const vCommitFileUploadRequest = v.object({
  uploadId: v.string(),
  multipart: v.optional(vCommitUploadDto),
});

export const vObjectDto = v.object({
  id: v.string(),
  objectType: v.optional(v.string()),
});

/**
 * User details of who created this object
 */
export const vUserDetailsDto = v.object({
  status: v.optional(v.string()),
  id: v.optional(v.string()),
  tiduuid: v.optional(v.string()),
  email: v.optional(v.string()),
  firstName: v.optional(v.string()),
  lastName: v.optional(v.string()),
});

/**
 * Access control list mapping permissions to user or group identifiers. It accepts values READ, FULL_ACCESS, NO_ACCESS
 */
export const vFolderPermissionsAcl = v.object({
  READ: v.optional(v.array(v.string())),
  FULL_ACCESS: v.optional(v.array(v.string())),
  NO_ACCESS: v.optional(v.array(v.string())),
});

export const vFolderPermissionsDto = v.object({
  defaultAccess: v.optional(v.picklist(['READ', 'FULL_ACCESS', 'NO_ACCESS'])),
  acl: v.optional(vFolderPermissionsAcl),
  inheritance: v.optional(v.boolean()),
});

/**
 * Access control list mapping permissions to user or group identifiers. It accepts values READ,FULL_ACCESS
 */
export const vFilePermissionsAcl = v.object({
  READ: v.optional(v.array(v.string())),
  FULL_ACCESS: v.optional(v.array(v.string())),
});

export const vFilePermissionsDto = v.object({
  acl: v.optional(vFilePermissionsAcl),
});

/**
 * List of file and folder details (legacy).
 */
export const vFileFolderLegacyItem = v.object({
  id: v.optional(v.string()),
  vid: v.optional(v.string()),
  nm: v.optional(v.string()),
  pid: v.optional(v.string()),
  ptp: v.optional(v.string()),
  tp: v.optional(v.string()),
  ct: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  mt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  cid: v.optional(v.string()),
  mid: v.optional(v.string()),
  sz: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  tn: v.optional(v.string()),
  md5: v.optional(v.string()),
  rv: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  ra: v.optional(v.string()),
  fa: v.optional(v.string()),
  dat: v.optional(v.string()),
  ac: v.optional(v.array(v.string())),
  inh: v.optional(v.boolean()),
  tc: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  did: v.optional(v.string()),
  dt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * List of file/folder details
 */
export const vFileFolderItem = v.object({
  id: v.optional(v.string()),
  vid: v.optional(v.string()),
  nm: v.optional(v.string()),
  pid: v.optional(v.string()),
  ptp: v.optional(v.string()),
  tp: v.optional(v.string()),
  ct: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  mt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  cid: v.optional(v.string()),
  mid: v.optional(v.string()),
  sz: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  del: v.optional(v.boolean()),
  tn: v.optional(v.string()),
  md5: v.optional(v.string()),
  chid: v.optional(v.string()),
  cht: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  rv: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  ra: v.optional(v.string()),
  fa: v.optional(v.string()),
  dat: v.optional(v.string()),
  ac: v.optional(v.array(v.string())),
  inh: v.optional(v.boolean()),
});

export const vFileFolderObjSyncResponse = v.object({
  items: v.optional(v.array(vFileFolderItem)),
  next: v.optional(v.string()),
  type: v.optional(v.string()),
});

export const vFolderDetailsMinimalResponse = v.object({
  id: v.optional(v.string()),
  versionId: v.optional(v.string()),
  parentId: v.optional(v.string()),
  parentVersionId: v.optional(v.string()),
  parentType: v.optional(v.string()),
  name: v.optional(v.string()),
  type: v.optional(v.string()),
  projectId: v.optional(v.string()),
  size: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  path: v.optional(v.string()),
  createdBy: v.optional(v.string()),
  modifiedBy: v.optional(v.string()),
  createdOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  modifiedOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

export const vFileOrFolderDetailsResponse = v.object({
  id: v.optional(v.string()),
  versionId: v.optional(v.string()),
  parentId: v.optional(v.string()),
  parentVersionId: v.optional(v.string()),
  parentType: v.optional(v.string()),
  name: v.optional(v.string()),
  type: v.optional(v.string()),
  projectId: v.optional(v.string()),
  size: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  path: v.optional(v.string()),
  thumbnailUrl: v.optional(v.string()),
  createdBy: v.optional(v.string()),
  modifiedBy: v.optional(v.string()),
  createdOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  modifiedOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

export const vFileDetailsResponse = v.object({
  id: v.optional(v.string()),
  versionId: v.optional(v.string()),
  parentId: v.optional(v.string()),
  parentVersionId: v.optional(v.string()),
  parentType: v.optional(v.string()),
  name: v.optional(v.string()),
  type: v.optional(v.string()),
  projectId: v.optional(v.string()),
  size: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  path: v.optional(v.string()),
  thumbnailUrl: v.optional(v.string()),
  createdBy: v.optional(v.string()),
  modifiedBy: v.optional(v.string()),
  createdOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  modifiedOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  _actions: v.optional(v.array(v.string())),
});

export const vFileUploadStatusDto = v.object({
  id: v.optional(v.string()),
  status: v.optional(v.string()),
  versionId: v.optional(v.string()),
  name: v.optional(v.string()),
  type: v.optional(v.string()),
  format: v.optional(v.string()),
  projectId: v.optional(v.string()),
  modifiedOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

export const vFileFolderResponse = v.object({
  items: v.optional(v.array(vFileFolderItem)),
  next: v.optional(v.string()),
});

export const vReservedViewDataApiDto = v.object({
  app: v.string(),
  data: v.record(v.string(), v.unknown()),
  createdBy: v.string(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  modifiedBy: v.string(),
  modifiedAt: v.pipe(v.string(), v.isoTimestamp()),
});

/**
 * CompanyDetailsResponse
 */
export const vCompanyDetailsResponse: v.GenericSchema = v.object({
  id: v.string(),
  name: v.string(),
  website: v.string(),
  domains: v.array(v.string()),
  image: v.string(),
  role: v.string(),
  createdOn: v.string(),
  modifiedOn: v.string(),
  createdBy: v.lazy(() => vCreatedBy),
  modifiedBy: vModifiedBy,
});

/**
 * CreatedBy
 *
 * User details of who created this object
 */
export const vCreatedBy: v.GenericSchema = v.object({
  id: v.string(),
  tiduuid: v.optional(v.string()),
  firstName: v.string(),
  lastName: v.string(),
  email: v.string(),
  status: v.picklist(['ACTIVE', 'PENDING', 'REMOVED']),
  company: v.optional(v.lazy(() => vCompany)),
  companies: v.optional(v.array(v.lazy(() => vCompany))),
  companyAdmin: v.optional(v.boolean()),
});

/**
 * Company
 */
export const vCompany = v.object({
  id: v.optional(v.string()),
  name: v.string(),
  website: v.string(),
  image: v.string(),
  role: v.string(),
  createdOn: v.string(),
  modifiedOn: v.string(),
  createdBy: vCreatedBy,
  modifiedBy: vModifiedBy,
});

/**
 * ViewProjectDetailsResponse
 */
export const vProjectDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  crs: v.optional(vCrs),
  rootId: v.string(),
  thumbnail: v.string(),
  address: v.optional(vAddress),
  location: v.string(),
  lastVisitedOn: v.string(),
  modifiedOn: v.string(),
  createdOn: v.string(),
  updatedOn: v.string(),
  createdBy: vCreatedBy,
  modifiedBy: vModifiedBy,
  updatedBy: vUpdatedBy,
  size: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  filesCount: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  foldersCount: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  versionsCount: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  usersCount: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  description: v.string(),
  startDate: v.string(),
  endDate: v.string(),
  access: v.picklist(['FULL_ACCESS', 'NO_ACCESS']),
  license: v.optional(vLicense),
});

/**
 * ListProjectUsersResponse
 */
export const vListProjectUsersResponse = v.object({
  id: v.string(),
  tiduuid: v.optional(v.string()),
  firstName: v.string(),
  lastName: v.string(),
  email: v.string(),
  status: v.picklist(['ACTIVE', 'PENDING', 'REMOVED']),
  hasImage: v.boolean(),
  thumbnail: v.string(),
  role: v.string(),
  company: v.optional(vCompany),
  companies: v.optional(v.array(vCompany)),
  createdOn: v.string(),
  modifiedOn: v.string(),
  lastAccessed: v.string(),
  companyAdmin: v.optional(v.boolean()),
  modifiedBy: vModifiedBy,
  createdBy: vCreatedBy,
});

/**
 * UserDetailsResponse
 */
export const vUserDetailsResponse = v.object({
  id: v.string(),
  tiduuid: v.optional(v.string()),
  firstName: v.optional(v.string()),
  lastName: v.optional(v.string()),
  email: v.string(),
  status: v.picklist(['ACTIVE', 'PENDING', 'REMOVED']),
  viewerBackground: v.optional(vViewerBackground),
  timeZone: v.string(),
  title: v.optional(v.string()),
  skypeId: v.optional(v.string()),
  linkedinId: v.optional(v.string()),
  phone: v.optional(v.string()),
  podLocation: v.optional(v.string()),
  hasImage: v.boolean(),
  thumbnail: v.optional(v.string()),
  language: v.string(),
  role: v.string(),
  company: v.optional(vCompany),
  companies: v.optional(v.array(vCompany)),
  createdOn: v.string(),
  modifiedOn: v.string(),
  lastAccessed: v.optional(v.string()),
  companyAdmin: v.optional(v.boolean()),
});

/**
 * FolderDetailsResponse
 */
export const vFolderDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  type: v.string(),
  versionId: v.string(),
  parentId: v.string(),
  parentType: v.string(),
  permission: v.picklist(['READ', 'FULL_ACCESS']),
  createdBy: vCreatedBy,
  createdOn: v.string(),
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  size: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  projectId: v.string(),
  hasChildren: v.boolean(),
  path: v.array(vPath),
  tags: v.array(vTags),
});

/**
 * ListItemsinaFolderResponse
 */
export const vListItemsinaFolderResponse = v.object({
  id: v.string(),
  name: v.string(),
  type: v.picklist(['FOLDER', 'FILE']),
  versionId: v.string(),
  parentId: v.string(),
  parentType: v.picklist(['FOLDER', 'TODO']),
  permission: v.optional(v.picklist(['READ', 'FULL_ACCESS'])),
  _actions: v.optional(
    v.picklist([
      'folder:Create',
      'folder:Delete',
      'folder:EditPermission',
      'folder:Get',
      'folder:GetPermission',
      'folder:List',
      'folder:Restore',
      'folder:Update',
      'file:Create',
      'file:Delete',
      'file:EditPermission',
      'file:Get',
      'file:GetPermission',
      'file:List',
      'file:Restore',
      'file:Update',
    ])
  ),
  createdBy: vCreatedBy,
  createdOn: v.string(),
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  size: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  projectId: v.string(),
  hasChildren: v.optional(v.boolean()),
  path: v.array(vPath),
  tags: v.array(v.string()),
  revision: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  thumbnailUrl: v.optional(v.array(v.string())),
  hash: v.optional(v.string()),
  status: v.optional(
    v.picklist([
      'PENDING',
      'ON HOLD',
      'DONE',
      'CANCELLED',
      'ERROR',
      'PROCESSING',
    ])
  ),
});

/**
 * ListItemsinaFolderResponseV21
 */
export const vListItemsinaFolderResponseV21 = v.object({
  id: v.string(),
  name: v.string(),
  type: v.string(),
  versionId: v.string(),
  parentId: v.string(),
  parentType: v.string(),
  createdBy: vCreatedBy,
  createdOn: v.string(),
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  projectId: v.string(),
  hasChildren: v.optional(v.boolean()),
  revision: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  thumbnailUrl: v.optional(v.array(v.string())),
  hash: v.optional(v.string()),
  status: v.optional(v.string()),
  size: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  path: v.optional(v.array(vPath)),
  tags: v.optional(v.array(v.string())),
  _actions: v.optional(
    v.picklist([
      'folder:Create',
      'folder:Delete',
      'folder:EditPermission',
      'folder:Get',
      'folder:GetPermission',
      'folder:List',
      'folder:Restore',
      'folder:Update',
      'file:Create',
      'file:Delete',
      'file:EditPermission',
      'file:Get',
      'file:GetPermission',
      'file:List',
      'file:Restore',
      'file:Update',
    ])
  ),
});

/**
 * GetalignmentResponse
 */
export const vGetalignmentResponse = v.object({
  id: v.string(),
  locationX: v.number(),
  locationY: v.number(),
  locationZ: v.number(),
  axisX: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  axisY: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  axisZ: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  refDirectionX: v.number(),
  refDirectionY: v.number(),
  refDirectionZ: v.number(),
  scale: v.number(),
  versionId: v.string(),
  fileId: v.string(),
  revision: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  createdOn: v.string(),
  modifiedOn: v.string(),
  createdBy: vCreatedBy,
  modifiedBy: vModifiedBy,
});

/**
 * CreateAlignmentWithMatrixResponse
 */
export const vCreateAlignmentWithMatrixResponse = v.object({
  id: v.string(),
  matrix: v.array(v.number()),
  fileId: v.string(),
  versionId: v.string(),
  createdOn: v.string(),
  modifiedOn: v.string(),
  createdBy: vCreatedBy,
  modifiedBy: vModifiedBy,
});

/**
 * GroupDetailsResponse
 */
export const vGroupDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  projectId: v.string(),
  createdBy: vCreatedBy,
  modifiedBy: vModifiedBy,
  createdOn: v.string(),
  modifiedOn: v.string(),
  usersCount: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
});

/**
 * ReleaseDetailsResponse
 */
export const vReleaseDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  status: v.picklist(['OPEN', 'SENT']),
  projectId: v.string(),
  dueDate: v.string(),
  notes: v.string(),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  filesCount: v.number(),
});

/**
 * ShareDetailsResponse
 */
export const vShareDetailsResponse = v.object({
  id: v.string(),
  mode: v.picklist(['PROJECT_USERS', 'REGISTERED_USERS', 'PUBLIC']),
  expiryDate: v.optional(v.string()),
  projectId: v.string(),
  notify: v.array(vNotify),
  message: v.string(),
  objects: v.array(vShareObject),
  permission: v.picklist(['VIEW', 'DOWNLOAD']),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
});

/**
 * CreateShareResponse
 */
export const vCreateShareResponse = v.object({
  id: v.string(),
  mode: v.picklist(['PROJECT_USERS', 'REGISTERED_USERS', 'PUBLIC']),
  expiryDate: v.optional(v.string()),
  projectId: v.string(),
  notify: v.array(vNotify),
  message: v.string(),
  objects: v.array(vCreateShareObject),
  permission: v.picklist(['VIEW', 'DOWNLOAD']),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
});

/**
 * ShareTokenDetailsResponse
 */
export const vShareTokenDetailsResponse = v.object({
  id: v.string(),
  mode: v.picklist(['PROJECT_USERS', 'REGISTERED_USERS', 'PUBLIC']),
  expiryDate: v.optional(v.string()),
  projectId: v.string(),
  notify: v.array(vNotify),
  message: v.string(),
  objects: v.array(vShareObject),
  permission: v.picklist(['VIEW', 'DOWNLOAD']),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  accessToken: v.string(),
});

/**
 * ToDoDetailsResponse
 */
export const vToDoDetailsResponse = v.object({
  id: v.string(),
  type: v.optional(
    v.picklist([
      'Fault',
      'Clash',
      'Request',
      'Inquiry',
      'Remark',
      'Comment',
      'Issue',
      'Request',
      'Solution',
    ])
  ),
  title: v.string(),
  label: v.string(),
  description: v.string(),
  dueDate: v.optional(v.string()),
  percentComplete: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1'),
      v.minValue(0),
      v.maxValue(100)
    )
  ),
  status: v.picklist(['NEW', 'IN_PROGRESS', 'RESOLVED', 'BLOCKED', 'CLOSED']),
  priority: v.picklist(['LOW', 'NORMAL', 'HIGH', 'CRITICAL']),
  projectId: v.string(),
  assignees: v.optional(vAssigneeResponse),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
});

/**
 * ViewGroupDetailsResponse
 */
export const vViewGroupDetailsResponse = v.object({
  id: v.string(),
  views: v.array(v.string()),
  createdOn: v.string(),
  modifiedOn: v.string(),
  createdBy: vCreatedBy,
  modifiedBy: vModifiedBy,
  name: v.string(),
  projectId: v.string(),
});

/**
 * ViewDetailsResponse
 */
export const vViewDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  description: v.string(),
  projectId: v.string(),
  topicId: v.optional(v.string()),
  issueId: v.optional(v.string()),
  contextId: v.optional(v.string()),
  models: v.array(v.string()),
  files: v.array(v.string()),
  assignees: v.optional(v.array(vAssigneeResponse)),
  thumbnail: v.string(),
  image: v.optional(v.string()),
  createdOn: v.string(),
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  backgroundColor: v.optional(vBackgroundColor),
  createdBy: vCreatedBy,
  camera: vCamera,
  sectionPlanes: v.optional(v.array(vSectionPlane)),
  sectionBox: v.optional(vSectionBox),
  markups: v.optional(v.array(vMarkup)),
  presentation: v.optional(vPresentation),
});

/**
 * 2DViewDetailsResponse
 */
export const v2dViewDetailsResponse: v.GenericSchema = v.object({
  id: v.string(),
  createdOn: v.string(),
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  createdBy: vCreatedBy,
  name: v.string(),
  description: v.string(),
  versionId: v.string(),
  projectId: v.string(),
  fileId: v.string(),
  thumbnail: v.string(),
  rotation: v.string(),
  zoomLevel: v.string(),
  pageNumber: v.string(),
  assignees: v.array(vAssigneeResponse),
  markup: v.optional(v2dViewMarkup),
  tags: v.optional(v.lazy(() => vTagDetailsResponse)),
});

/**
 * ObjectLinkResponse
 */
export const vObjectLinkResponse = v.object({
  id: v.string(),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
  name: v.optional(v.string()),
  source: vSourceResponse,
  target: vTarget,
});

/**
 * ClashDetailsResponse
 */
export const vClashDetailsResponse = v.object({
  id: v.string(),
  name: v.string(),
  projectId: v.string(),
  tolerance: v.number(),
  type: v.picklist(['CLASH', 'CLEARANCE']),
  status: v.number(),
  count: v.number(),
  ignoreSameDiscipline: v.boolean(),
  models: v.array(v.string()),
  files: v.array(v.string()),
  assignees: v.optional(vAssigneeResponse),
  modifiedOn: v.string(),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedBy: vModifiedBy,
});

/**
 * CommentDetailsResponse
 */
export const vCommentDetailsResponse = v.object({
  id: v.string(),
  description: v.string(),
  objectId: v.string(),
  objectType: v.picklist([
    'FILE',
    'FOLDER',
    'VIEW',
    'CLASH',
    'RELEASE',
    'TODO',
    'ISSUE',
  ]),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
});

/**
 * CommentDetailsWithReactionsSummaryResponse
 */
export const vCommentDetailsWithReactionsSummaryResponse = v.intersect([
  vCommentDetailsResponse,
  v.object({
    reactionsSummary: v.optional(
      v.array(
        v.object({
          emoji: v.optional(v.string()),
          count: v.optional(v.pipe(v.number(), v.integer())),
        })
      )
    ),
  }),
]);

/**
 * TagDetailsResponse
 */
export const vTagDetailsResponse = v.object({
  id: v.string(),
  label: v.string(),
  description: v.string(),
  color: v.optional(v.string()),
  projectId: v.string(),
  createdOn: v.string(),
  createdBy: vCreatedBy,
  modifiedOn: v.string(),
  modifiedBy: vModifiedBy,
});

/**
 * ListAllSearchResultsResponse
 *
 * The listing items are of different types, so the details for the schema will vary per type
 */
export const vListAllSearchResultsResponse: v.GenericSchema = v.object({
  type: v.string(),
  details: v.lazy(() => vSearchDetails),
});

/**
 * SearchDetails
 */
export const vSearchDetails = v.object({
  id: v.string(),
  label: v.optional(v.string()),
  description: v.optional(v.string()),
  status: v.optional(v.union([v.string(), v.null()])),
  priority: v.optional(v.union([v.string(), v.null()])),
  projectId: v.string(),
  modifiedBy: v.optional(vModifiedBy),
  createdOn: v.string(),
  modifiedOn: v.string(),
  name: v.optional(v.string()),
  dueDate: v.optional(v.string()),
  notes: v.optional(v.string()),
  type: v.optional(
    v.picklist([
      'PROJECT',
      'FOLDER',
      'FILE',
      'TODO',
      'RELEASE',
      'VIEW',
      'CLASH',
    ])
  ),
  count: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  ignoreSameDiscipline: v.optional(v.string()),
  ignoreSameFile: v.optional(v.string()),
  models: v.optional(v.array(v.string())),
  tolerance: v.optional(v.number()),
  clearance: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  createdBy: v.optional(vCreatedBy),
  versionId: v.optional(v.string()),
  path: v.optional(v.array(vPath)),
  size: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  hasChildren: v.optional(v.boolean()),
  hash: v.optional(v.string()),
});

/**
 * The application name
 */
export const vReservedAppName = v.picklist([
  'numark',
  'maya',
  'worksmanager',
  'trcps',
]);

export const vListAllProjectsV21Data = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      fields: v.optional(v.string()),
      pageSize: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(50)),
        25
      ),
      skipToken: v.optional(v.string()),
      sortBy: v.optional(
        v.picklist([
          '+name',
          '-name',
          '+size',
          '-size',
          '+lastVisited',
          '-lastVisited',
          '+updatedAt',
          '-updatedAt',
        ])
      ),
    })
  ),
});

/**
 * Successfully retrieved projects list
 */
export const vListAllProjectsV21Response = vProjectsPagedResponseV21;

export const vListActivitiesofaProjectObjectData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
    objectId: v.optional(v.string()),
    objectType: v.optional(v.string()),
    filters: v.optional(v.string()),
    lastId: v.optional(v.string()),
  }),
});

export const vListActivitiesofaProjectObjectResponse = v.array(
  vActivityDetailsResponse
);

export const vPostCreateanewexportRequestData = v.object({
  body: vCreateNewExportRequest,
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
  }),
});

export const vPostCreateanewexportRequestResponse = vActivityExportDetails;

export const vGetExportdetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    exportId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetExportdetailsResponse = vActivityExportDetails;

export const vPostActivitiesListData = v.object({
  body: vActivityListRequest,
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      objectId: v.optional(v.string()),
      objectType: v.optional(v.string()),
      pageSize: v.optional(v.number(), 15),
      lastId: v.optional(v.string()),
    })
  ),
});

/**
 * The `details` contains the corresponding object associated with the activity. A minimal representation is provided in the `ActivityObject`. If the client needs additional information about the object, use the corresponding resource endpoint. <br> In case of multiple activities clubbed together, the count is provided in the `statistics`. To fetch additional information in case of multiple activities, use the [/activities/logs](#/activities/logs) endpoint. To fetch additional information about the object, use the corresponding resource endpoints based on the type of object.
 */
export const vPostActivitiesListResponse = v.array(vActivityListResponse);

export const vActivityDetailsbyactivityIdData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    activityId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vActivityDetailsbyactivityIdResponse = vActivityDetailsResponse;

export const vActivitylogsbyactivityIdData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    activityId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vActivitylogsbyactivityIdResponse = v.array(
  vActivityLogsByActivityIdResponse
);

export const vDeleteClashData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    clashId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteClashResponse = v.void();

export const vListAllClashItemsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    clashId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListAllClashItemsResponse2 = v.array(vListAllClashItemsResponse);

export const vDeleteCommentData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    commentId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteCommentResponse = v.void();

export const vDeleteRemoveattachmentsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    commentId: v.string(),
  }),
  query: v.object({
    id: v.string(),
    type: v.string(),
  }),
});

export const vDeleteRemoveattachmentsResponse = v.void();

export const vGetListallattachmentsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    commentId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetListallattachmentsResponse = v.array(
  vCommentAttachmentDetailsResponse
);

export const vPostAddattachmentsData = v.object({
  body: v.array(vAddCommentAttachmentsRequest),
  path: v.object({
    commentId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vPostAddattachmentsResponse = v.array(
  vCommentAttachmentDetailsResponse
);

export const vListReactionsToCommentData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    commentId: v.string(),
  }),
  query: v.optional(
    v.object({
      pageSize: v.optional(
        v.pipe(v.number(), v.minValue(1), v.maxValue(100)),
        100
      ),
      skipToken: v.optional(v.string()),
    })
  ),
});

export const vListReactionsToCommentResponse = v.object({
  items: v.optional(v.array(vAddReactionToCommentResponse)),
  links: v.optional(vPaginationLinks),
});

export const vAddReactionToCommentData = v.object({
  body: vAddReactionToCommentRequest,
  path: v.object({
    commentId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * User has added a new reaction for the comment.
 */
export const vAddReactionToCommentResponse2 = vAddReactionToCommentResponse;

export const vDeleteReactionToCommentData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    commentId: v.string(),
    reactionId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * Deletion was successful
 */
export const vDeleteReactionToCommentResponse = v.void();

export const vRemoveCompanyEmailDomainsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    companyId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vRemoveCompanyEmailDomainsResponse = v.void();

export const vAddCompanyEmailDomainsData = v.object({
  body: v.array(v.string()),
  path: v.object({
    companyId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vAddCompanyEmailDomainsResponse = v.array(v.string());

export const vRemoveUsersfromCompanyData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    companyId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vRemoveUsersfromCompanyResponse = v.void();

export const vRemoveUserfromtheCompanyData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    companyId: v.string(),
    userId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vRemoveUserfromtheCompanyResponse = v.void();

export const vUploadFileData = v.object({
  body: v.optional(vFileCreationRequest),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vUploadFileResponse = vFileDetailsResponse;

export const vCreateNewExportRequestData = v.object({
  body: v.array(v.string()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
  }),
});

export const vCreateNewExportRequestResponse = vFileExportDetails;

export const vGetExportDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    exportId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetExportDetailsResponse = vFileExportDetails;

export const vListSupported2D3dSpatialfileformatsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      fileType: v.optional(v.string()),
    })
  ),
});

export const vListSupported2D3dSpatialfileformatsResponse =
  vListSupported2D3dSpatialFileFormatsResponse;

export const vCommitFileUploadData = v.object({
  body: vCommitFileUploadRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'tc-enable-process': v.optional(v.string()),
      'If-Match': v.optional(v.string()),
      Digest: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

export const vInitiateFileUploadData = v.object({
  body: v.optional(vInitiateFileUploadRequest),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      fileId: v.optional(v.string()),
      versionId: v.optional(v.string()),
      format: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

export const vGetActiveFileFolderSnapshotData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
    includeDeleted: v.optional(v.boolean(), false),
    includeAttachment: v.optional(v.boolean(), false),
    skipToken: v.optional(v.string()),
    maxItems: v.optional(
      v.pipe(
        v.union([v.number(), v.string(), v.bigint()]),
        v.transform((x) => BigInt(x)),
        v.minValue(
          BigInt('-9223372036854775808'),
          'Invalid value: Expected int64 to be >= -2^63'
        ),
        v.maxValue(
          BigInt('9223372036854775807'),
          'Invalid value: Expected int64 to be <= 2^63-1'
        )
      ),
      BigInt(100000)
    ),
    objectTypes: v.optional(v.string(), 'FILE,FOLDER'),
    objectNames: v.optional(v.string()),
    id: v.optional(v.string()),
    includeRoot: v.optional(v.boolean(), false),
    includeActions: v.optional(v.boolean(), false),
  }),
});

/**
 * OK
 */
export const vGetActiveFileFolderSnapshotResponse = vFileFolderResponse;

export const vGetFileUploadDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    uploadId: v.string(),
    wait: v.optional(v.boolean()),
  }),
});

/**
 * OK
 */
export const vGetFileUploadDetailsResponse = vFileUploadDetailsResponse;

export const vInitiateFilePackageUploadData = v.object({
  body: vFileUploadDto,
  path: v.optional(v.never()),
  query: v.object({
    parentId: v.string(),
    parentType: v.string(),
    syncSessionId: v.optional(v.string()),
    batchId: v.optional(v.string()),
  }),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
      'tc-enable-process': v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * ACCEPTED
 */
export const vInitiateFilePackageUploadResponse = vFileUploadDetailsResponse;

export const vCompleteMultipartFileUploadData = v.object({
  body: vCompleteUploadRequestDto,
  path: v.object({
    uploadId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.object({
    Digest: v.string(),
  }),
});

/**
 * No Content
 */
export const vCompleteMultipartFileUploadResponse = v.void();

export const vGetFileUploadStatusData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    uploadId: v.string(),
  }),
});

/**
 * OK
 */
export const vGetFileUploadStatusResponse = vFileUploadStatusDto;

export const vDownloadUrlData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      versionId: v.optional(v.string()),
      format: v.optional(v.picklist(['TRB', 'PDF', 'THUMBNAIL', 'GEOJSON'])),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vDownloadUrlResponse2 = vDownloadUrlResponse;

export const vDeleteFileData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      batchId: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vDeleteFileResponse = v.void();

export const vGetFileDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      versionId: v.optional(v.string()),
      include: v.optional(v.array(v.string())),
      fields: v.optional(v.array(v.string())),
      minimal: v.optional(v.boolean(), true),
    })
  ),
});

export const vGetFileDetailsResponse = vFileDetailsResponse;

export const vUpdateFileDetailsData = v.object({
  body: vUpdateFileDetailsRequest,
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vUpdateFileDetailsResponse = vFileDetailsResponse;

export const vDeletealignmentData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      versionId: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vDeletealignmentResponse = v.void();

export const vCheckinFileData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      batchId: v.optional(v.string()),
    })
  ),
});

export const vCheckinFileResponse = vFileDetailsResponse;

export const vCheckoutFileData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      batchId: v.optional(v.string()),
    })
  ),
});

export const vCheckoutFileResponse = vFileDetailsResponse;

export const vGetFilePermissionsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vGetFilePermissionsResponse = vFilePermissionsDto;

export const vPatchFilePermissionsData = v.object({
  body: vFilePermissionsDto,
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vPatchFilePermissionsResponse = vFilePermissionsDto;

export const vGetprocessingstatusofaFileData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.object({
    versionId: v.optional(v.string()),
    format: v.picklist(['TRB', 'PDF', 'THUMBNAIL', 'GEOJSON']),
  }),
});

export const vGetprocessingstatusofaFileResponse2 =
  vGetprocessingstatusofaFileResponse;

export const vGetversionsofaFileData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      include: v.optional(v.array(v.string())),
    })
  ),
});

export const vGetversionsofaFileResponse = v.array(vFileDetailsResponse);

export const vGetFolderPermissionsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(
    v.object({
      fields: v.optional(v.array(v.string())),
    })
  ),
});

/**
 * OK
 */
export const vGetFolderPermissionsResponse = vFolderPermissionsDto;

export const vPatchFolderPermissionsData = v.object({
  body: vFolderPermissionsDto,
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vPatchFolderPermissionsResponse = vFolderPermissionsDto;

export const vGetFolderDeletionJobStatusData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    jobId: v.string(),
  }),
  query: v.optional(
    v.object({
      wait: v.optional(v.boolean()),
      fields: v.optional(v.string()),
    })
  ),
});

export const vDeleteFolderData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(
    v.object({
      batchId: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vDeleteFolderResponse = v.void();

export const vDeleteFolder2Data = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(
    v.object({
      force: v.optional(v.boolean(), false),
      syncSessionId: v.optional(v.string()),
      batchId: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vDeleteFolder2Response = v.union([v.unknown(), v.void()]);

export const vGetFileFolderDetailsByNameData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.object({
    name: v.string(),
    type: v.optional(v.string()),
    fields: v.optional(v.array(v.string())),
  }),
});

/**
 * OK
 */
export const vGetFileFolderDetailsByNameResponse = vFileOrFolderDetailsResponse;

export const vRemoveanyexistingFolderPermissionData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vRemoveanyexistingFolderPermissionResponse = v.void();

export const vGetFolderPermissions2Data = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetFolderPermissions2Response = vFolderPermissionsResponse;

export const vUpdateexistingFolderPermissionData = v.object({
  body: vFolderPermissionRequest,
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vUpdateexistingFolderPermissionResponse =
  vFolderPermissionsResponse;

export const vAddaNewFolderPermissionData = v.object({
  body: vFolderPermissionRequest,
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vAddaNewFolderPermissionResponse = vFolderPermissionsResponse;

export const vDeleteGroupData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    groupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteGroupResponse = v.void();

export const vDeleteusersfromgroupData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    groupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteusersfromgroupResponse = v.void();

export const vListUsersinaGroupData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    groupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListUsersinaGroupResponse = v.array(vUsersinaGroupResponse);

export const vAdduserstogroupData = v.object({
  body: v.array(vAdduserstogroupRequest),
  path: v.object({
    groupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vAdduserstogroupResponse = v.array(vUsersinaGroupResponse);

export const vDeleteaobjectlinkData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    linkId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteaobjectlinkResponse = v.void();

export const vRequestProjectAccessData = v.object({
  body: vProjectAccessRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCloneProjectData = v.object({
  body: vProjectCloneRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCloneProjectResponse = vProjectCloneResponse;

export const vGetProjectCloneDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    cloneId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetProjectCloneDetailsResponse = vGetProjectCloneResponse;

export const vListAllProjectsMiniData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * Succesfull Response
 */
export const vListAllProjectsMiniResponse = v.array(vProjectMeResponse);

export const vDeleteProjectData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteProjectResponse = v.void();

export const vGetProjectlicensedetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetProjectlicensedetailsResponse = vLicense;

export const vUpdateProjectLicenseDetailsData = v.object({
  body: v.object({
    id: v.optional(v.string()),
    subscriptionId: v.optional(v.string()),
  }),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetProjectMetricsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetProjectMetricsResponse = vProjectMetricsResponse;

export const vGetProjectSyncObjectsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.object({
    status: v.string(),
    types: v.optional(v.string()),
    includeTopicEmbedded: v.optional(v.boolean(), false),
    format: v.optional(v.string(), 'v1'),
    skipToken: v.optional(v.string()),
    maxItems: v.optional(
      v.pipe(
        v.union([v.number(), v.string(), v.bigint()]),
        v.transform((x) => BigInt(x)),
        v.minValue(
          BigInt('-9223372036854775808'),
          'Invalid value: Expected int64 to be >= -2^63'
        ),
        v.maxValue(
          BigInt('9223372036854775807'),
          'Invalid value: Expected int64 to be <= 2^63-1'
        )
      )
    ),
  }),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
    })
  ),
});

export const vGetProjectSyncObjectsResponse = v.union([
  vObjectSyncFetchObjectList,
  vFileFolderObjSyncResponse,
]);

export const vListrolesavailableinprojectData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListrolesavailableinprojectResponse = v.array(v.string());

export const vGetProjectsettingsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.picklist(['sync', 'notifications', 'unit'])),
    })
  ),
});

export const vGetProjectsettingsResponse = vGetProjectSettingsResponse;

export const vUpdateProjectSettingsData = v.object({
  body: vUpdateProjectSettingsRequest,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetProjectSyncStatusData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      encode: v.optional(v.boolean(), true),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * The the project content sync cursor. If `encode` query parameter is `true` or missing only the `status` property is returned, otherwise response contains all individual sync cursors for all resource types. Content of individual resource cursors should not be interpreted by client in any way and used as an opaque string for equality operations only.
 */
export const vGetProjectSyncStatusResponse = v.object({
  status: v.optional(v.string()),
  projectId: v.optional(v.string()),
  modifiedOn: v.optional(v.string()),
  projectMetadataTs: v.optional(v.string()),
  teamTs: v.optional(v.string()),
  groupsTs: v.optional(v.string()),
  filesTs: v.optional(v.string()),
  foldersTs: v.optional(v.string()),
  fsobjTs: v.optional(v.string()),
  alignmentTs: v.optional(v.string()),
  thumbnailTs: v.optional(v.string()),
  permissionsTs: v.optional(v.string()),
  commentsTs: v.optional(v.string()),
  tagTs: v.optional(v.string()),
  todosTs: v.optional(v.string()),
  releasesTs: v.optional(v.string()),
  clashesTs: v.optional(v.string()),
  viewsTs: v.optional(v.string()),
  views2dTs: v.optional(v.string()),
  viewGroupsTs: v.optional(v.string()),
  objectlinkTs: v.optional(v.string()),
});

export const vRemoveuserData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
    userId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vRemoveuserResponse = v.void();

export const vGetProjectUserDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
    userId: v.string(),
  }),
  query: v.optional(
    v.object({
      minimal: v.optional(v.boolean()),
    })
  ),
});

export const vGetProjectUserDetailsResponse = vGetUserDetailsResponse;

export const vGetAvailableRegionsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vGetAvailableRegionsResponse2 = v.array(
  vGetAvailableRegionsResponse
);

export const vDownloadfilesinreleaseData = v.object({
  body: v.array(v.string()),
  path: v.optional(v.never()),
  query: v.object({
    releaseId: v.string(),
  }),
});

export const vDeleteReleaseData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    releaseId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteReleaseResponse = v.void();

export const vRemovefilesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    releaseId: v.string(),
  }),
  query: v.object({
    id: v.string(),
    type: v.string(),
  }),
});

export const vRemovefilesResponse = v.void();

export const vListallfilesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    releaseId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListallfilesResponse = v.array(vReleaseFileResponse);

export const vAddfilesData = v.object({
  body: v.array(vAddReleaseFilesRequest),
  path: v.object({
    releaseId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vAddfilesResponse = v.array(vReleaseFileResponse);

export const vDeleteShareData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    shareId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteShareResponse = v.void();

export const vDeleteTagData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tagId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteTagResponse = v.void();

export const vRemoveobjectsfromTagData = v.object({
  body: v.array(vObjectsToTagRequest),
  path: v.object({
    tagId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vRemoveobjectsfromTagResponse = v.void();

export const vListobjectsinaTagData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tagId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListobjectsinaTagResponse = v.array(vObjectsinaTagResponse);

export const vAddobjectstoTagData = v.object({
  body: v.array(vObjectsToTagRequest),
  path: v.object({
    tagId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vAddobjectstoTagResponse = v.array(vObjectsinaTagResponse);

export const vListallTodoTypesofaProjectData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
  }),
});

export const vListallTodoTypesofaProjectResponse = v.array(v.string());

export const vDeleteToDoData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    todoId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteToDoResponse = v.void();

export const vRemoveattachmentsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    todoId: v.string(),
  }),
  query: v.object({
    id: v.string(),
    type: v.string(),
  }),
});

export const vRemoveattachmentsResponse = v.void();

export const vListallattachmentsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    todoId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListallattachmentsResponse = v.array(
  vTodoAttachmentDetailsResponse
);

export const vAddattachmentsData = v.object({
  body: v.array(vAddTodoattachmentsRequest),
  path: v.object({
    todoId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vAddattachmentsResponse = v.array(vTodoAttachmentDetailsResponse);

export const vListAllSupportedLanguagesData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vListAllSupportedLanguagesResponse = v.array(v.string());

export const vListUserLicensesData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vListUserLicensesResponse = v.array(vLicense);

export const vListAllAvailableTimezonesData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vListAllAvailableTimezonesResponse = v.array(v.string());

export const vDeleteViewGroupData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewGroupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteViewGroupResponse = v.void();

export const vDeleteViewData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(
    v.object({
      force: v.optional(v.boolean()),
    })
  ),
});

export const vDeleteViewResponse = v.void();

export const vGetCameraDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetCameraDetailsResponse = vCamera;

export const vUpdateCameraData = v.object({
  body: vUpdateCameraRequest,
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateCameraResponse = vCamera;

export const vGetViewImageData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetViewImageResponse = v.string();

export const vUploadViewThumbnailImageData = v.object({
  body: v.object({
    file: v.optional(v.string()),
  }),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUploadViewThumbnailImageResponse2 =
  vUploadViewThumbnailImageResponse;

export const vListMarkupsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListMarkupsResponse = vMarkup;

export const vUpdateMarkupData = v.object({
  body: v.array(vUpdateMarkupRequest),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateMarkupResponse = v.array(vMarkup);

export const vCreateMarkupsData = v.object({
  body: v.array(vCreateMarkupsRequest),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vCreateMarkupsResponse = v.array(vMarkup);

export const vDeleteMarkupData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
    markupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteMarkupResponse = v.void();

export const vGetPresentationData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetPresentationResponse = vPresentation;

export const vUpdatePresentationData = v.object({
  body: vUpdatePresentationRequest,
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdatePresentationResponse = vPresentation;

export const vDeleteSectionBoxData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteSectionBoxResponse = v.void();

export const vGetSectionBoxData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetSectionBoxResponse = vSectionBox;

export const vUpdateSectionBoxData = v.object({
  body: vUpdateSectionBoxRequest,
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateSectionBoxResponse = vSectionBox;

export const vListSectionPlanesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListSectionPlanesResponse = v.array(vSectionPlane);

export const vUpdateSectionPlaneData = v.object({
  body: v.array(vUpdateSectionPlaneRequest),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateSectionPlaneResponse = v.array(vSectionPlane);

export const vCreateSectionPlaneData = v.object({
  body: v.array(vCreateSectionPlaneRequest),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vCreateSectionPlaneResponse = v.array(vSectionPlane);

export const vDeleteSectionPlaneData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
    sectionplaneId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteSectionPlaneResponse = v.void();

export const vDelete2dViewData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(
    v.object({
      force: v.optional(v.boolean()),
    })
  ),
});

export const vDelete2dViewResponse = v.void();

export const vDeleteReservedViewDataData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.object({
    app: v.picklist(['numark', 'maya', 'worksmanager', 'trcps']),
  }),
});

/**
 * Successfully deleted reserved data
 */
export const vDeleteReservedViewDataResponse = v.void();

export const vGetReservedViewDataData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.object({
    app: v.picklist(['numark', 'maya', 'worksmanager', 'trcps']),
  }),
});

/**
 * Successfully retrieved reserved data
 */
export const vGetReservedViewDataResponse = vReservedViewDataApiDto;

export const vPutReservedViewDataData = v.object({
  body: v.record(v.string(), v.unknown()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.object({
    app: v.picklist(['numark', 'maya', 'worksmanager', 'trcps']),
  }),
});

/**
 * Successfully updated existing reserved data
 */
export const vPutReservedViewDataResponse = vReservedViewDataApiDto;

export const vListItemsinaFolderByPathData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    path: v.string(),
    projectId: v.string(),
    fields: v.optional(v.string()),
    pageSize: v.optional(
      v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(500)),
      100
    ),
    skipToken: v.optional(v.string()),
    sort: v.optional(
      v.picklist(['+name', '-name', '+size', '-size', '+modified', '-modified'])
    ),
  }),
});

/**
 * Successfully retrieved items in the folder specified by path.
 */
export const vListItemsinaFolderByPathResponse = v.object({
  items: v.optional(v.array(vListItemsinaFolderResponseV21)),
  links: v.optional(vPaginationLinks),
});

export const vListItemsinaFolderData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(
    v.object({
      fields: v.optional(v.string()),
      pageSize: v.optional(
        v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(500)),
        100
      ),
      skipToken: v.optional(v.string()),
      sort: v.optional(
        v.picklist([
          '+name',
          '-name',
          '+size',
          '-size',
          '+modified',
          '-modified',
        ])
      ),
      objectTypes: v.optional(v.string()),
    })
  ),
});

/**
 * Successfully retrieved items in the folder.
 */
export const vListItemsinaFolderResponse2 = v.object({
  items: v.optional(v.array(vListItemsinaFolderResponseV21)),
  links: v.optional(vPaginationLinks),
});

export const vListallClashesinaprojectData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
  }),
});

export const vListallClashesinaprojectResponse = v.array(vClashDetailsResponse);

export const vCreateaNewClashData = v.object({
  body: vCreateClashRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNewClashResponse = vClashDetailsResponse;

export const vGetClashDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    clashId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetClashDetailsResponse = vClashDetailsResponse;

export const vUpdateClashData = v.object({
  body: vUpdateClashRequest,
  path: v.object({
    clashId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateClashResponse = vClashDetailsResponse;

export const vListallCommentsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    objectId: v.string(),
    objectType: v.picklist([
      'FILE',
      'FOLDER',
      'VIEW',
      'CLASH',
      'RELEASE',
      'TODO',
      'ISSUE',
    ]),
    include: v.optional(v.string()),
    contextId: v.optional(v.string()),
  }),
});

export const vListallCommentsResponse = v.array(
  vCommentDetailsWithReactionsSummaryResponse
);

export const vCreateaNewCommentData = v.object({
  body: vCreateaNewCommentRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNewCommentResponse = vCommentDetailsResponse;

export const vGetCommentDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    commentId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetCommentDetailsResponse = vCommentDetailsResponse;

export const vUpdateCommentData = v.object({
  body: vUpdateCommentRequest,
  path: v.object({
    commentId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateCommentResponse = vCommentDetailsResponse;

export const vListCompaniesData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vListCompaniesResponse = v.array(vCompanyDetailsResponse);

export const vGetCompanyDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    companyId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetCompanyDetailsResponse = vCompanyDetailsResponse;

export const vUpdateCompanyData = v.object({
  body: vUpdateCompanyRequest,
  path: v.object({
    companyId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateCompanyResponse = vCompanyDetailsResponse;

export const vUploadCompanyImageData = v.object({
  body: v.string(),
  path: v.object({
    companyId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUploadCompanyImageResponse = vCompanyDetailsResponse;

export const vListUsersinaCompanyData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    companyId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListUsersinaCompanyResponse = v.array(vUserDetailsResponse);

export const vAddUserstoCompanyData = v.object({
  body: v.array(vAddUserstoCompanyRequest),
  path: v.object({
    companyId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vAddUserstoCompanyResponse = v.array(vUserDetailsResponse);

export const vUpdateUserintheCompanyData = v.object({
  body: vUpdateUserintheCompanyRequest,
  path: v.object({
    companyId: v.string(),
    userId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateUserintheCompanyResponse = vUserDetailsResponse;

export const vGetalignmentData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      versionId: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vGetalignmentResponse2 = vGetalignmentResponse;

export const vCreateAlignmentData = v.object({
  body: vCreateAlignmentRequest,
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      versionId: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vCreateAlignmentResponse = vGetalignmentResponse;

export const vCreatealignmentwithmatrixData = v.object({
  body: vCreateAlignmentWithMatrixRequest,
  path: v.object({
    fileId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vCreatealignmentwithmatrixResponse =
  vCreateAlignmentWithMatrixResponse;

export const vCreateaNewFolderData = v.object({
  body: vCreateaNewFolderRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNewFolderResponse = vFolderDetailsResponse;

export const vListItemsinaFolderbypathData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    path: v.string(),
    projectId: v.string(),
  }),
});

export const vListItemsinaFolderbypathResponse = v.array(
  vListItemsinaFolderResponse
);

export const vGetFolderDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(
    v.object({
      versionId: v.optional(v.string()),
      fields: v.optional(v.array(v.string())),
      minimal: v.optional(v.boolean(), true),
    })
  ),
});

export const vGetFolderDetailsResponse = vFolderDetailsResponse;

export const vUpdateFolderData = v.object({
  body: vUpdateFolderRequest,
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(
    v.object({
      syncSessionId: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vUpdateFolderResponse = vFolderDetailsResponse;

export const vListItemsinaFolderV21Data = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(
    v.object({
      include: v.optional(v.array(v.string())),
    })
  ),
});

export const vListItemsinaFolderV21Response = v.array(
  vListItemsinaFolderResponse
);

export const vGetversionsofaFolderData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    folderId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetversionsofaFolderResponse = v.array(vFolderDetailsResponse);

export const vListGroupsinaprojectData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
  }),
});

export const vListGroupsinaprojectResponse = v.array(vGroupDetailsResponse);

export const vCreateaNewGroupData = v.object({
  body: vCreateaNewGroupRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNewGroupResponse = vGroupDetailsResponse;

export const vGetGroupDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    groupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetGroupDetailsResponse = vGroupDetailsResponse;

export const vRenameGroupData = v.object({
  body: vRenameGroupRequest,
  path: v.object({
    groupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vRenameGroupResponse = vGroupDetailsResponse;

export const vListlinkedentitiesforobjectsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      id: v.optional(v.string()),
      versionId: v.optional(v.string()),
      sourceId: v.optional(v.string()),
      modifiedAfter: v.optional(v.pipe(v.string(), v.isoTimestamp())),
      includeDeleted: v.optional(v.boolean()),
      detail: v.optional(v.boolean()),
      showOrphanLinks: v.optional(v.boolean()),
    })
  ),
});

export const vListlinkedentitiesforobjectsResponse = vObjectLinkResponse;

export const vCreateobjectlinkData = v.object({
  body: vCreateObjectLinkRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateobjectlinkResponse = vObjectLinkResponse;

export const vBulkcreateobjectlinksData = v.object({
  body: v.array(vBulkCreateObjectLinksRequest),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vBulkcreateobjectlinksResponse = v.array(vObjectLinkResponse);

export const vListlinksforthegiventargetentityData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
    type: v.string(),
    id: v.string(),
    contextId: v.optional(v.string()),
    versionId: v.string(),
    modifiedAfter: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    includeDeleted: v.boolean(),
  }),
});

export const vListlinksforthegiventargetentityResponse =
  v.array(vObjectLinkResponse);

export const vUpdateobjectlinksData = v.object({
  body: vUpdateObjectLinksRequest,
  path: v.object({
    linkId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateobjectlinksResponse = vObjectLinkResponse;

export const vListallProjectsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      fullyLoaded: v.optional(v.boolean()),
      minimal: v.optional(v.boolean()),
      sort: v.optional(v.string()),
      include: v.optional(v.string()),
    })
  ),
});

export const vListallProjectsResponse = v.union([
  v.array(vProjectDetailsResponse),
  v.array(vProjectMinimalDetailsResponse),
]);

export const vCreateaNewProjectData = v.object({
  body: vCreateaNewProjectRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNewProjectResponse = vProjectDetailsResponse;

export const vGetProjectDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      fullyLoaded: v.optional(v.boolean()),
      include: v.optional(v.string()),
    })
  ),
});

export const vGetProjectDetailsResponse = vProjectDetailsResponse;

export const vUpdateProjectData = v.object({
  body: vUpdateProjectRequest,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateProjectResponse = vProjectDetailsResponse;

export const vUploadProjectImageData = v.object({
  body: v.optional(
    v.object({
      file: v.optional(v.string()),
    })
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUploadProjectImageResponse = vProjectDetailsResponse;

export const vListallUsersinprojectData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vListallUsersinprojectResponse = v.array(
  vListProjectUsersResponse
);

export const vAddInviteUserstoprojectData = v.object({
  body: vAddUserstoprojectRequest,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      notify: v.optional(v.boolean()),
    })
  ),
});

export const vAddInviteUserstoprojectResponse = vUserDetailsResponse;

export const vUpdateUserroleData = v.object({
  body: vUpdateUserroleRequest,
  path: v.object({
    projectId: v.string(),
    userId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateUserroleResponse = vUserDetailsResponse;

export const vListallReleasesData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
    status: v.optional(v.string()),
  }),
});

export const vListallReleasesResponse = v.array(vReleaseDetailsResponse);

export const vCreateaNewReleaseData = v.object({
  body: vCreateaNewReleaseRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNewReleaseResponse = vReleaseDetailsResponse;

export const vGetReleaseDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    releaseId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetReleaseDetailsResponse = vReleaseDetailsResponse;

export const vEditReleaseData = v.object({
  body: vEditReleaseRequest,
  path: v.object({
    releaseId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vEditReleaseResponse = vReleaseDetailsResponse;

export const vListAllSearchResultsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    query: v.string(),
    projectId: v.optional(v.string()),
    type: v.optional(v.string()),
    startDate: v.optional(v.string()),
    endDate: v.optional(v.string()),
    sort: v.optional(v.string()),
  }),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
    })
  ),
});

export const vListAllSearchResultsResponse2 = v.array(
  vListAllSearchResultsResponse
);

export const vListallSharesData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      projectId: v.optional(v.string()),
      includeFields: v.optional(v.picklist(['path', 'parentId'])),
    })
  ),
});

export const vListallSharesResponse = v.array(vShareDetailsResponse);

export const vCreateaNewShareData = v.object({
  body: vCreateaNewShareRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNewShareResponse = vCreateShareResponse;

export const vGetShareDetailsWithAccessTokenUsingStokenData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    stoken: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetShareDetailsWithAccessTokenUsingStokenResponse =
  vShareTokenDetailsResponse;

export const vGetShareDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    shareId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetShareDetailsResponse = vShareDetailsResponse;

export const vEditShareData = v.object({
  body: vEditShareRequest,
  path: v.object({
    shareId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vEditShareResponse = vShareDetailsResponse;

export const vListTagsinaprojectData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      projectId: v.optional(v.string()),
      objectId: v.optional(v.string()),
      contextId: v.optional(v.string()),
      objectType: v.optional(v.string()),
      includeDeletedObjects: v.optional(v.boolean()),
      miniRep: v.optional(v.boolean()),
    })
  ),
});

export const vListTagsinaprojectResponse = v.array(v.unknown());

export const vCreateTagData = v.object({
  body: vCreateTagRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateTagResponse = vTagDetailsResponse;

export const vGetTagDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    tagId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetTagDetailsResponse = vTagDetailsResponse;

export const vEditTagData = v.object({
  body: vEditTagRequest,
  path: v.object({
    tagId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vEditTagResponse = vTagDetailsResponse;

export const vListallToDosData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
    fileId: v.optional(v.string()),
    versionId: v.optional(v.string()),
  }),
});

export const vListallToDosResponse = v.array(vToDoDetailsResponse);

export const vCreateaNewToDoData = v.object({
  body: vCreateaNewToDoRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNewToDoResponse = vToDoDetailsResponse;

export const vGetToDoDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    todoId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetToDoDetailsResponse = vToDoDetailsResponse;

export const vUpdateToDoData = v.object({
  body: vUpdateToDoRequest,
  path: v.object({
    todoId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateToDoResponse = vToDoDetailsResponse;

export const vGetUserDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    userId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetUserDetailsResponse2 = vUserDetailsResponse;

export const vUpdateUserDetailsData = v.object({
  body: vUpdateUserDetailsRequest,
  path: v.object({
    userId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateUserDetailsResponse = vUserDetailsResponse;

export const vListallViewGroupsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
  }),
});

export const vListallViewGroupsResponse = v.array(vViewGroupDetailsResponse);

export const vCreateaViewGroupData = v.object({
  body: vCreateaViewGroupRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaViewGroupResponse = vViewGroupDetailsResponse;

export const vGetViewGroupDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewGroupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetViewGroupDetailsResponse = vViewGroupDetailsResponse;

export const vUpdateViewGroupDetailsData = v.object({
  body: vUpdateViewGroupDetailsRequest,
  path: v.object({
    viewGroupId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateViewGroupDetailsResponse = vViewGroupDetailsResponse;

export const vListallViewsinaprojectData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.object({
    projectId: v.string(),
    fileId: v.optional(v.string()),
    versionId: v.optional(v.string()),
    topicId: v.optional(v.string()),
    issueId: v.optional(v.string()),
    contextId: v.optional(v.string()),
    detail: v.optional(v.boolean(), false),
    includeEmbedded: v.optional(v.boolean(), false),
    includeTopicEmbedded: v.optional(v.boolean(), false),
  }),
});

export const vListallViewsinaprojectResponse = v.array(vViewDetailsResponse);

export const vCreateViewData = v.object({
  body: vCreateViewRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateViewResponse = vViewDetailsResponse;

export const vCreateViewWithThumbnailData = v.object({
  body: v.optional(
    v.object({
      view: v.optional(vCreateViewRequest),
      imageData: v.optional(v.string()),
    })
  ),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateViewWithThumbnailResponse = vViewDetailsResponse;

export const vUpdateViewWithThumbnailData = v.object({
  body: v.optional(
    v.object({
      view: v.optional(vUpdateViewRequest),
      imageData: v.optional(v.string()),
    })
  ),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateViewWithThumbnailResponse = vViewDetailsResponse;

export const vGetViewDetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetViewDetailsResponse = vViewDetailsResponse;

export const vUpdateViewData = v.object({
  body: vUpdateViewRequest,
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdateViewResponse = vViewDetailsResponse;

export const vListall2dViewsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      projectId: v.optional(v.string()),
      fileId: v.optional(v.string()),
      versionId: v.optional(v.string()),
      detail: v.optional(v.boolean()),
    })
  ),
});

export const vListall2dViewsResponse = v.array(v2dViewDetailsResponse);

export const vCreateaNew2dViewData = v.object({
  body: vCreatea2dViewRequest,
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreateaNew2dViewResponse = v2dViewDetailsResponse;

export const vCreatea2dViewMultipartData = v.object({
  body: v.object({
    view: v.optional(vCreatea2dViewRequest),
    imageData: v.optional(v.string()),
  }),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vCreatea2dViewMultipartResponse = v2dViewDetailsResponse;

export const vUpdate2dViewMultipartData = v.object({
  body: v.object({
    view: v.optional(vUpdate2dViewRequest),
    imageData: v.optional(v.string()),
  }),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdate2dViewMultipartResponse = v2dViewDetailsResponse;

export const vGet2dViewdetailsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGet2dViewdetailsResponse = v2dViewDetailsResponse;

export const vUpdate2dViewData = v.object({
  body: vUpdate2dViewRequest,
  path: v.object({
    viewId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUpdate2dViewResponse = v2dViewDetailsResponse;
